import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
};

export type AgenziaNode = Node & {
  __typename?: 'AgenziaNode';
  /** The ID of the object */
  id: Scalars['ID'];
  ragioneSociale: Scalars['String'];
  indirizzo: Scalars['String'];
  cap: Scalars['String'];
  comune: Scalars['String'];
  provincia: Scalars['String'];
  telefono: Scalars['String'];
  /** Impedisce la geolocalizzazione automatica */
  bloccaGeolocalizzazione: Scalars['Boolean'];
  latitudine?: Maybe<Scalars['String']>;
  longitudine?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  codice: Scalars['String'];
  email: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
};

export type AgenziaNodeConnection = {
  __typename?: 'AgenziaNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgenziaNodeEdge>>;
};

/** A Relay edge containing a `AgenziaNode` and its cursor. */
export type AgenziaNodeEdge = {
  __typename?: 'AgenziaNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<AgenziaNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type AutocompleteConnection = {
  __typename?: 'AutocompleteConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutocompleteEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  suggestion?: Maybe<Scalars['String']>;
};


export type AutocompleteConnectionSuggestionArgs = {
  query: Scalars['String'];
};

/** A Relay edge containing a `Autocomplete` and its cursor. */
export type AutocompleteEdge = {
  __typename?: 'AutocompleteEdge';
  /** The item at the end of the edge */
  node?: Maybe<SearchType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type BreadcrumbType = {
  __typename?: 'BreadcrumbType';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CategoriaFaqNode = Node & {
  __typename?: 'CategoriaFaqNode';
  /** The ID of the object */
  id: Scalars['ID'];
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  alias?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugIt?: Maybe<Scalars['String']>;
  titolo?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  chiaveIcona?: Maybe<Scalars['String']>;
  macroCategoria?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  faq?: Maybe<Array<Maybe<FaqNode>>>;
  pk?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
};

export type CategoriaFaqNodeConnection = {
  __typename?: 'CategoriaFaqNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaFaqNodeEdge>>;
};

/** A Relay edge containing a `CategoriaFaqNode` and its cursor. */
export type CategoriaFaqNodeEdge = {
  __typename?: 'CategoriaFaqNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<CategoriaFaqNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type CategoriaNode = Node & {
  __typename?: 'CategoriaNode';
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  titolo: Scalars['String'];
  descrizione?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugIt?: Maybe<Scalars['String']>;
  statoPubblicazione: CategorieCategoriaStatoPubblicazioneChoices;
  visibilitaDal?: Maybe<Scalars['String']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  nome: Scalars['String'];
  nomeIt?: Maybe<Scalars['String']>;
  codice: Scalars['String'];
  tipo?: Maybe<Scalars['String']>;
  icona?: Maybe<Scalars['String']>;
  offerte?: Maybe<Array<Maybe<OffertaNode>>>;
  categoriaPrimariaDefault?: Maybe<CategoriaNode>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  categorieAsCategoriaPrimariaDefault: CategoriaNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  contentTypeId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  filtriId?: Maybe<Array<Maybe<Scalars['String']>>>;
  pagina?: Maybe<PaginaNode>;
  categoriePrimarie?: Maybe<Array<Maybe<CategoriaNode>>>;
  parent?: Maybe<CategoriaNode>;
  adminUrl?: Maybe<Scalars['String']>;
  modelClass?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  pubblicato?: Maybe<Scalars['Boolean']>;
};


export type CategoriaNodeCategorieAsCategoriaPrimariaDefaultArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  tipo?: Maybe<Scalars['String']>;
};

export type CategoriaNodeConnection = {
  __typename?: 'CategoriaNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaNodeEdge>>;
};

/** A Relay edge containing a `CategoriaNode` and its cursor. */
export type CategoriaNodeEdge = {
  __typename?: 'CategoriaNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<CategoriaNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type CategoriaVeicoloNode = Node & {
  __typename?: 'CategoriaVeicoloNode';
  /** The ID of the object */
  id: Scalars['ID'];
  alias: Scalars['String'];
  nome: Scalars['String'];
  slug: Scalars['String'];
  ordinamento: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  pk?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type CategoriaVeicoloNodeConnection = {
  __typename?: 'CategoriaVeicoloNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaVeicoloNodeEdge>>;
};

/** A Relay edge containing a `CategoriaVeicoloNode` and its cursor. */
export type CategoriaVeicoloNodeEdge = {
  __typename?: 'CategoriaVeicoloNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<CategoriaVeicoloNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum CategorieCategoriaStatoPubblicazioneChoices {
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO',
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO'
}

export type CentroConvenzionatoNode = Node & {
  __typename?: 'CentroConvenzionatoNode';
  /** The ID of the object */
  id: Scalars['ID'];
  ragioneSociale: Scalars['String'];
  indirizzo: Scalars['String'];
  cap: Scalars['String'];
  comune: Scalars['String'];
  provincia: Scalars['String'];
  telefono: Scalars['String'];
  /** Impedisce la geolocalizzazione automatica */
  bloccaGeolocalizzazione: Scalars['Boolean'];
  latitudine?: Maybe<Scalars['String']>;
  longitudine?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  codice: Scalars['String'];
  isUnipolservice: Scalars['Boolean'];
  tipi: TipoCentroConvenzionatoNodeConnection;
  marche: MarcaCentroConvenzionatoNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  nomiMarche?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CentroConvenzionatoNodeTipiArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type CentroConvenzionatoNodeMarcheArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  marca?: Maybe<Scalars['String']>;
  tipoId?: Maybe<Scalars['ID']>;
};

export type CentroConvenzionatoNodeConnection = {
  __typename?: 'CentroConvenzionatoNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CentroConvenzionatoNodeEdge>>;
};

/** A Relay edge containing a `CentroConvenzionatoNode` and its cursor. */
export type CentroConvenzionatoNodeEdge = {
  __typename?: 'CentroConvenzionatoNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<CentroConvenzionatoNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type ComunicatiType = Node & {
  __typename?: 'ComunicatiType';
  /** The ID of the object */
  id: Scalars['ID'];
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  titolo: Scalars['String'];
  slug: Scalars['String'];
  descrizione?: Maybe<Scalars['String']>;
  dataPubblicazione?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  allegato?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
};

export type ComunicatiTypeConnection = {
  __typename?: 'ComunicatiTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ComunicatiTypeEdge>>;
};

/** A Relay edge containing a `ComunicatiType` and its cursor. */
export type ComunicatiTypeEdge = {
  __typename?: 'ComunicatiTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<ComunicatiType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type CreateRichiestaContatto = {
  __typename?: 'CreateRichiestaContatto';
  status?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  leadId?: Maybe<Scalars['String']>;
};

export type CreateUtenteNewsletter = {
  __typename?: 'CreateUtenteNewsletter';
  status?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};




export type FaqNode = Node & {
  __typename?: 'FaqNode';
  /** The ID of the object */
  id: Scalars['ID'];
  domanda: Scalars['String'];
  domandaIt?: Maybe<Scalars['String']>;
  risposta?: Maybe<Scalars['String']>;
  rispostaIt?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  slugIt?: Maybe<Scalars['String']>;
  categoria: CategoriaFaqNode;
  inOfferta: Scalars['Boolean'];
  piuFrequente: Scalars['Boolean'];
  ordine: Scalars['Int'];
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  pk?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  titolo: Scalars['String'];
};

export type FilialeNode = Node & {
  __typename?: 'FilialeNode';
  /** The ID of the object */
  id: Scalars['ID'];
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  ragioneSociale: Scalars['String'];
  indirizzo: Scalars['String'];
  cap: Scalars['String'];
  comune: Scalars['String'];
  provincia: Scalars['String'];
  telefono: Scalars['String'];
  /** Impedisce la geolocalizzazione automatica */
  bloccaGeolocalizzazione: Scalars['Boolean'];
  latitudine?: Maybe<Scalars['String']>;
  longitudine?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  email: Scalars['String'];
  fax: Scalars['String'];
  orari: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  titolo?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
};

export type FilialeNodeConnection = {
  __typename?: 'FilialeNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FilialeNodeEdge>>;
};

/** A Relay edge containing a `FilialeNode` and its cursor. */
export type FilialeNodeEdge = {
  __typename?: 'FilialeNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<FilialeNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};


export type IndirizzoNode = Node & {
  __typename?: 'IndirizzoNode';
  /** The ID of the object */
  id: Scalars['ID'];
  nome?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  indirizzo?: Maybe<Scalars['String']>;
  citta?: Maybe<Scalars['String']>;
  provincia?: Maybe<Scalars['String']>;
  cap?: Maybe<Scalars['String']>;
  utente?: Maybe<UtenteNode>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  pk?: Maybe<Scalars['Int']>;
};

export type IndirizzoNodeConnection = {
  __typename?: 'IndirizzoNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IndirizzoNodeEdge>>;
};

/** A Relay edge containing a `IndirizzoNode` and its cursor. */
export type IndirizzoNodeEdge = {
  __typename?: 'IndirizzoNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<IndirizzoNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type LandingNode = Node & {
  __typename?: 'LandingNode';
  /** The ID of the object */
  id: Scalars['ID'];
  alias: Scalars['String'];
  nome: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  offertaInEvidenza?: Maybe<OffertaLandingNode>;
  offerte?: Maybe<OffertaLandingNodeConnection>;
  convenzioni?: Maybe<Array<Maybe<Scalars['String']>>>;
  agenzie?: Maybe<Array<Maybe<Scalars['String']>>>;
  pk?: Maybe<Scalars['Int']>;
  siteId?: Maybe<Scalars['Int']>;
};


export type LandingNodeOfferteArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type LandingNodeConnection = {
  __typename?: 'LandingNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LandingNodeEdge>>;
};

/** A Relay edge containing a `LandingNode` and its cursor. */
export type LandingNodeEdge = {
  __typename?: 'LandingNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<LandingNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type Logout = {
  __typename?: 'Logout';
  status?: Maybe<Scalars['Boolean']>;
};

export type MagazineType = Node & {
  __typename?: 'MagazineType';
  /** The ID of the object */
  id: Scalars['ID'];
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  titolo: Scalars['String'];
  slug: Scalars['String'];
  descrizione?: Maybe<Scalars['String']>;
  dataPubblicazione?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  immagine?: Maybe<Scalars['String']>;
  allegato?: Maybe<Scalars['String']>;
  tags: Array<TagType>;
  pk?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
  newsCorrelate?: Maybe<Array<Maybe<MagazineType>>>;
};

export type MagazineTypeConnection = {
  __typename?: 'MagazineTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MagazineTypeEdge>>;
};

/** A Relay edge containing a `MagazineType` and its cursor. */
export type MagazineTypeEdge = {
  __typename?: 'MagazineTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<MagazineType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type MarcaCentroConvenzionatoNode = Node & {
  __typename?: 'MarcaCentroConvenzionatoNode';
  /** The ID of the object */
  id: Scalars['ID'];
  marca: Scalars['String'];
  tipo: TipoCentroConvenzionatoNode;
  marchiCentriConvenzionati: CentroConvenzionatoNodeConnection;
  pk?: Maybe<Scalars['Int']>;
};


export type MarcaCentroConvenzionatoNodeMarchiCentriConvenzionatiArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  tipi_Id?: Maybe<Scalars['Decimal']>;
  marche_Id?: Maybe<Scalars['Decimal']>;
};

export type MarcaCentroConvenzionatoNodeConnection = {
  __typename?: 'MarcaCentroConvenzionatoNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MarcaCentroConvenzionatoNodeEdge>>;
};

/** A Relay edge containing a `MarcaCentroConvenzionatoNode` and its cursor. */
export type MarcaCentroConvenzionatoNodeEdge = {
  __typename?: 'MarcaCentroConvenzionatoNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<MarcaCentroConvenzionatoNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type MarcaVeicoloNode = Node & {
  __typename?: 'MarcaVeicoloNode';
  /** The ID of the object */
  id: Scalars['ID'];
  alias: Scalars['String'];
  nome: Scalars['String'];
  slug: Scalars['String'];
  sigla: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  pk?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type MarcaVeicoloNodeConnection = {
  __typename?: 'MarcaVeicoloNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MarcaVeicoloNodeEdge>>;
};

/** A Relay edge containing a `MarcaVeicoloNode` and its cursor. */
export type MarcaVeicoloNodeEdge = {
  __typename?: 'MarcaVeicoloNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<MarcaVeicoloNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum Modello {
  Offerta = 'offerta',
  Categoria = 'categoria',
  News = 'news',
  Magazine = 'magazine',
  Comunicati = 'comunicati',
  Pagina = 'pagina',
  Faq = 'faq'
}

export type Mutation = {
  __typename?: 'Mutation';
  createUtenteNewsletter?: Maybe<CreateUtenteNewsletter>;
  createRichiestaContatto?: Maybe<CreateRichiestaContatto>;
  recuperaPassword?: Maybe<RecuperaPassword>;
  resetPassword?: Maybe<ResetPassword>;
  tokenAuth?: Maybe<ObtainJsonWebToken>;
  verifyToken?: Maybe<Verify>;
  logout?: Maybe<Logout>;
};


export type MutationCreateUtenteNewsletterArgs = {
  input: RichiestaIscrizioneNewsletterInput;
};


export type MutationCreateRichiestaContattoArgs = {
  input: RichiestaContattoInput;
};


export type MutationRecuperaPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationTokenAuthArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationVerifyTokenArgs = {
  token?: Maybe<Scalars['String']>;
};

export type NewsType = Node & {
  __typename?: 'NewsType';
  /** The ID of the object */
  id: Scalars['ID'];
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  titolo: Scalars['String'];
  slug: Scalars['String'];
  descrizione?: Maybe<Scalars['String']>;
  dataPubblicazione?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  immagine?: Maybe<Scalars['String']>;
  allegato?: Maybe<Scalars['String']>;
  tags: Array<TagType>;
  pk?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  pagina?: Maybe<PaginaNode>;
  newsCorrelate?: Maybe<Array<Maybe<NewsType>>>;
};

export type NewsTypeConnection = {
  __typename?: 'NewsTypeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NewsTypeEdge>>;
};

/** A Relay edge containing a `NewsType` and its cursor. */
export type NewsTypeEdge = {
  __typename?: 'NewsTypeEdge';
  /** The item at the end of the edge */
  node?: Maybe<NewsType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

export type ObtainJsonWebToken = {
  __typename?: 'ObtainJSONWebToken';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  user?: Maybe<UtenteNode>;
  token: Scalars['String'];
};

export type OffertaLandingNode = Node & {
  __typename?: 'OffertaLandingNode';
  /** The ID of the object */
  id: Scalars['ID'];
  alias: Scalars['String'];
  nome: Scalars['String'];
  descrizione: Scalars['String'];
  condizioni: Scalars['String'];
  /** Anticipo (iva inclusa) */
  anticipo?: Maybe<Scalars['Float']>;
  prezzoIi?: Maybe<Scalars['Float']>;
  prezzoScontatoIi?: Maybe<Scalars['Float']>;
  prezzoIe?: Maybe<Scalars['Float']>;
  prezzoScontatoIe?: Maybe<Scalars['Float']>;
  risparmioDipendenteIi?: Maybe<Scalars['Float']>;
  risparmioDipendenteIe?: Maybe<Scalars['Float']>;
  image?: Maybe<Scalars['String']>;
  attiva: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  landingsAsInEvidenza: LandingNodeConnection;
  landings: LandingNodeConnection;
  pk?: Maybe<Scalars['Int']>;
};


export type OffertaLandingNodeLandingsAsInEvidenzaArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type OffertaLandingNodeLandingsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type OffertaLandingNodeConnection = {
  __typename?: 'OffertaLandingNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OffertaLandingNodeEdge>>;
};

/** A Relay edge containing a `OffertaLandingNode` and its cursor. */
export type OffertaLandingNodeEdge = {
  __typename?: 'OffertaLandingNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<OffertaLandingNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type OffertaNode = Node & {
  __typename?: 'OffertaNode';
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  titoloIt?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  titolo: Scalars['String'];
  descrizione?: Maybe<Scalars['String']>;
  alias: Scalars['String'];
  nome: Scalars['String'];
  nomeIt?: Maybe<Scalars['String']>;
  /** Identificativo del case Vetrina su Pega */
  idOfferta: Scalars['String'];
  slug: Scalars['String'];
  slugIt?: Maybe<Scalars['String']>;
  /** Note inserite dall'utente sulla vetrina */
  note?: Maybe<Scalars['String']>;
  /** Visibile sul sito Web */
  statoPubblicazione: OfferteOffertaStatoPubblicazioneChoices;
  visibilitaDal?: Maybe<Scalars['String']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  /** Promozione Web */
  promoWeb: Scalars['Boolean'];
  /** Quantità Auto disponibili */
  autoDisponibili?: Maybe<Scalars['Int']>;
  /** Auto del mese */
  autoMese: Scalars['Boolean'];
  /** Maxirata iva inclusa */
  anticipoIi?: Maybe<Scalars['Float']>;
  /** Maxirata iva esclusa */
  anticipoIe?: Maybe<Scalars['Float']>;
  veicolo?: Maybe<VeicoloNode>;
  ordinamento: Scalars['Int'];
  offerteCorrelate?: Maybe<Array<Maybe<OffertaNode>>>;
  responseText?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  /** Offerte associate alla categoria in alternativa ai valori attributo */
  categorie: CategoriaNodeConnection;
  scaglioni?: Maybe<Array<Maybe<ScaglioneNode>>>;
  offerte: OffertaNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  consegna60gg?: Maybe<Scalars['Boolean']>;
  prontaConsegna?: Maybe<Scalars['Boolean']>;
  gammaEcologica?: Maybe<Scalars['Boolean']>;
  anticipoZero?: Maybe<Scalars['Boolean']>;
  faqs?: Maybe<Array<Maybe<FaqNode>>>;
  pagina?: Maybe<PaginaNode>;
  categoria?: Maybe<CategoriaNode>;
  condizioniKm?: Maybe<Scalars['Int']>;
  condizioniMesi?: Maybe<Scalars['Int']>;
  prezzoIi?: Maybe<Scalars['Float']>;
  prezzoIe?: Maybe<Scalars['Float']>;
  adminUrl?: Maybe<Scalars['String']>;
  modelClass?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  pubblicato?: Maybe<Scalars['Boolean']>;
};


export type OffertaNodeCategorieArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  tipo?: Maybe<Scalars['String']>;
};


export type OffertaNodeOfferteArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  promoWeb?: Maybe<Scalars['Boolean']>;
};

export type OffertaNodeConnection = {
  __typename?: 'OffertaNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OffertaNodeEdge>>;
};

/** A Relay edge containing a `OffertaNode` and its cursor. */
export type OffertaNodeEdge = {
  __typename?: 'OffertaNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<OffertaNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** An enumeration. */
export enum OfferteOffertaStatoPubblicazioneChoices {
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO',
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO'
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PagesPaginaStatoPubblicazioneChoices {
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO',
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO'
}

/** An enumeration. */
export enum PagesPaginaTipologiaChoices {
  /** Pagina */
  Page = 'PAGE',
  /** Pagina applicazione */
  PageApp = 'PAGE_APP',
  /** Pagine Entità */
  PageAppMany = 'PAGE_APP_MANY'
}

export type PaginaNode = Node & {
  __typename?: 'PaginaNode';
  /** The ID of the object */
  id: Scalars['ID'];
  seoDescription?: Maybe<Scalars['String']>;
  seoDescriptionIt?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  seoTitleIt?: Maybe<Scalars['String']>;
  noindex: Scalars['Boolean'];
  titolo: Scalars['String'];
  titoloIt?: Maybe<Scalars['String']>;
  descrizione?: Maybe<Scalars['String']>;
  descrizioneIt?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  previewImage?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  statoPubblicazione: PagesPaginaStatoPubblicazioneChoices;
  visibilitaDal?: Maybe<Scalars['String']>;
  visibilitaAl?: Maybe<Scalars['String']>;
  nome?: Maybe<Scalars['String']>;
  nomeIt?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  slugIt?: Maybe<Scalars['String']>;
  tipologia: PagesPaginaTipologiaChoices;
  template?: Maybe<Scalars['String']>;
  parent?: Maybe<PaginaNode>;
  chiave?: Maybe<Scalars['String']>;
  chiaveMenu?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  inRicerca: Scalars['Boolean'];
  inSitemap: Scalars['Boolean'];
  children: PaginaNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['Int']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  seo?: Maybe<SeoType>;
  url?: Maybe<Scalars['String']>;
  adminUrl?: Maybe<Scalars['String']>;
  modelClass?: Maybe<Scalars['String']>;
  visibile?: Maybe<Scalars['Boolean']>;
  pubblicato?: Maybe<Scalars['Boolean']>;
};


export type PaginaNodeChildrenArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  tipologia?: Maybe<PagesPaginaTipologiaChoices>;
};

export type PaginaNodeConnection = {
  __typename?: 'PaginaNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaginaNodeEdge>>;
};

/** A Relay edge containing a `PaginaNode` and its cursor. */
export type PaginaNodeEdge = {
  __typename?: 'PaginaNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<PaginaNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  allComunicati?: Maybe<ComunicatiTypeConnection>;
  comunicati?: Maybe<ComunicatiType>;
  marcheTipoCentroConvenzionato?: Maybe<MarcaCentroConvenzionatoNodeConnection>;
  centriConvenzionati?: Maybe<CentroConvenzionatoNodeConnection>;
  filiali?: Maybe<FilialeNodeConnection>;
  agenzie?: Maybe<AgenziaNodeConnection>;
  tipiCentriConvenzionati?: Maybe<TipoCentroConvenzionatoNodeConnection>;
  filiale?: Maybe<FilialeNode>;
  centriConvenzionatiCarrozzerie?: Maybe<CentroConvenzionatoNodeConnection>;
  centriConvenzionatiGommisti?: Maybe<CentroConvenzionatoNodeConnection>;
  centriConvenzionatiOfficine?: Maybe<CentroConvenzionatoNodeConnection>;
  centriConvenzionatiCentriDiConsegna?: Maybe<CentroConvenzionatoNodeConnection>;
  centriConvenzionatiCentriCristalli?: Maybe<CentroConvenzionatoNodeConnection>;
  search?: Maybe<SearchConnection>;
  autocomplete?: Maybe<AutocompleteConnection>;
  allNews?: Maybe<NewsTypeConnection>;
  allMagazine?: Maybe<MagazineTypeConnection>;
  news?: Maybe<NewsType>;
  magazine?: Maybe<MagazineType>;
  categoriaFaq?: Maybe<CategoriaFaqNode>;
  categorieFaq?: Maybe<CategoriaFaqNodeConnection>;
  faqFrequenti?: Maybe<Array<Maybe<FaqNode>>>;
  categoria?: Maybe<CategoriaNode>;
  landing?: Maybe<LandingNode>;
  offerta?: Maybe<OffertaNode>;
  offerte?: Maybe<OffertaNodeConnection>;
  offerteBySlug?: Maybe<Array<Maybe<OffertaNode>>>;
  veicolo?: Maybe<VeicoloNode>;
  veicoli?: Maybe<VeicoloNodeConnection>;
  marca?: Maybe<MarcaVeicoloNode>;
  marche?: Maybe<MarcaVeicoloNodeConnection>;
  categoriaVeicolo?: Maybe<CategoriaVeicoloNode>;
  categorieVeicoli?: Maybe<CategoriaVeicoloNodeConnection>;
  offertaRedirect?: Maybe<RedirectType>;
  pagina?: Maybe<PaginaNode>;
  pagine?: Maybe<PaginaNodeConnection>;
  menuitem?: Maybe<TreeNodeNode>;
  menuitems?: Maybe<TreeNodeNodeConnection>;
  me?: Maybe<UtenteNode>;
};


export type QueryAllComunicatiArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  titolo?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryComunicatiArgs = {
  slug: Scalars['String'];
};


export type QueryMarcheTipoCentroConvenzionatoArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  marca?: Maybe<Scalars['String']>;
  tipoId?: Maybe<Scalars['ID']>;
};


export type QueryCentriConvenzionatiArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  tipi_Id?: Maybe<Scalars['Decimal']>;
  marche_Id?: Maybe<Scalars['Decimal']>;
};


export type QueryFilialiArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAgenzieArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryTipiCentriConvenzionatiArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryFilialeArgs = {
  slug: Scalars['String'];
};


export type QueryCentriConvenzionatiCarrozzerieArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCentriConvenzionatiGommistiArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCentriConvenzionatiOfficineArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCentriConvenzionatiCentriDiConsegnaArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCentriConvenzionatiCentriCristalliArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySearchArgs = {
  query: Scalars['String'];
  models?: Maybe<Array<Maybe<Modello>>>;
  limitAutocomplete?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAutocompleteArgs = {
  query: Scalars['String'];
  models?: Maybe<Array<Maybe<Modello>>>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAllNewsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  titolo?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryAllMagazineArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  titolo?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type QueryNewsArgs = {
  slug: Scalars['String'];
};


export type QueryMagazineArgs = {
  slug: Scalars['String'];
};


export type QueryCategoriaFaqArgs = {
  slug: Scalars['String'];
};


export type QueryCategorieFaqArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryFaqFrequentiArgs = {
  faqFrequenti: Scalars['Boolean'];
};


export type QueryCategoriaArgs = {
  slug: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
};


export type QueryLandingArgs = {
  siteId: Scalars['Int'];
};


export type QueryOffertaArgs = {
  slug: Scalars['String'];
  categoria?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
};


export type QueryOfferteArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  promoWeb?: Maybe<Scalars['Boolean']>;
};


export type QueryOfferteBySlugArgs = {
  slugs?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryVeicoloArgs = {
  slug: Scalars['String'];
};


export type QueryVeicoliArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryMarcaArgs = {
  slug: Scalars['String'];
};


export type QueryMarcheArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCategoriaVeicoloArgs = {
  slug: Scalars['String'];
};


export type QueryCategorieVeicoliArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryOffertaRedirectArgs = {
  slug: Scalars['String'];
};


export type QueryPaginaArgs = {
  chiave?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  contentTypeId?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
  siteId?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
};


export type QueryPagineArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  tipologia?: Maybe<PagesPaginaTipologiaChoices>;
};


export type QueryMenuitemArgs = {
  alias?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};


export type QueryMenuitemsArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  depth?: Maybe<Scalars['Int']>;
  attivo?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['Decimal']>;
};

export type RecuperaPassword = {
  __typename?: 'RecuperaPassword';
  status?: Maybe<Scalars['Boolean']>;
  hashEmail?: Maybe<Scalars['String']>;
};

export type RedirectType = {
  __typename?: 'RedirectType';
  redirect?: Maybe<Scalars['String']>;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  status?: Maybe<Scalars['Boolean']>;
};

export type RichiestaContattoInput = {
  siteId?: Maybe<Scalars['Int']>;
  nome: Scalars['String'];
  cognome: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  telefono?: Maybe<Scalars['String']>;
  provincia: Scalars['String'];
  ragioneSociale?: Maybe<Scalars['String']>;
  partitaIva?: Maybe<Scalars['String']>;
  codiceFiscale?: Maybe<Scalars['String']>;
  flottaPotenziale: Scalars['Int'];
  budgetMensilePrevisto?: Maybe<Scalars['String']>;
  tipologiaVeicolo?: Maybe<Scalars['String']>;
  modelloMacchina?: Maybe<Scalars['String']>;
  kmPercorsi?: Maybe<Scalars['String']>;
  messaggio?: Maybe<Scalars['String']>;
  convenzione?: Maybe<Scalars['String']>;
  agenzia?: Maybe<Scalars['String']>;
  carrozzeria?: Maybe<Scalars['String']>;
  informativaPrivacy: Scalars['Boolean'];
  privacy1?: Maybe<Scalars['Boolean']>;
  privacy2?: Maybe<Scalars['Boolean']>;
  privacy3?: Maybe<Scalars['Boolean']>;
  privacy4?: Maybe<Scalars['Boolean']>;
};

export type RichiestaIscrizioneNewsletterInput = {
  email: Scalars['String'];
};

export type ScaglioneNode = Node & {
  __typename?: 'ScaglioneNode';
  /** The ID of the object */
  id: Scalars['ID'];
  /** Km annui */
  km: Scalars['Int'];
  /** Durata in mesi */
  mesi: Scalars['Int'];
  canoneMaxirataIi?: Maybe<Scalars['Float']>;
  canoneMaxirataIe?: Maybe<Scalars['Float']>;
  canoneNoMaxirataIi?: Maybe<Scalars['Float']>;
  canoneNoMaxirataIe?: Maybe<Scalars['Float']>;
  /** Mostrato in listing */
  default: Scalars['Boolean'];
  offerta: OffertaNode;
  pk?: Maybe<Scalars['Int']>;
};

export type SearchConnection = {
  __typename?: 'SearchConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  suggestion?: Maybe<Scalars['String']>;
  autocomplete?: Maybe<AutocompleteConnection>;
};


export type SearchConnectionSuggestionArgs = {
  query: Scalars['String'];
};


export type SearchConnectionAutocompleteArgs = {
  query: Scalars['String'];
  models?: Maybe<Array<Maybe<Modello>>>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Search` and its cursor. */
export type SearchEdge = {
  __typename?: 'SearchEdge';
  /** The item at the end of the edge */
  node?: Maybe<SearchType>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type SearchObject = CategoriaNode | OffertaNode | NewsType | MagazineType | ComunicatiType | PaginaNode | FaqNode;

export type SearchType = Node & {
  __typename?: 'SearchType';
  /** The ID of the object */
  id: Scalars['ID'];
  object?: Maybe<SearchObject>;
  modelName?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
};

export type SeoType = {
  __typename?: 'SeoType';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  noindex?: Maybe<Scalars['Boolean']>;
};

export type TagType = {
  __typename?: 'TagType';
  id: Scalars['ID'];
  nome: Scalars['String'];
  newsSet: NewsTypeConnection;
  magazineSet: MagazineTypeConnection;
  pk?: Maybe<Scalars['Int']>;
};


export type TagTypeNewsSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  titolo?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};


export type TagTypeMagazineSetArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  titolo?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
};

export type TipoCentroConvenzionatoNode = Node & {
  __typename?: 'TipoCentroConvenzionatoNode';
  /** The ID of the object */
  id: Scalars['ID'];
  nome: Scalars['String'];
  nomeStatico: Scalars['String'];
  marcaTipoCentro?: Maybe<Array<Maybe<MarcaCentroConvenzionatoNode>>>;
  tipiCentriConvenzionati: CentroConvenzionatoNodeConnection;
  pk?: Maybe<Scalars['Int']>;
};


export type TipoCentroConvenzionatoNodeTipiCentriConvenzionatiArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  tipi_Id?: Maybe<Scalars['Decimal']>;
  marche_Id?: Maybe<Scalars['Decimal']>;
};

export type TipoCentroConvenzionatoNodeConnection = {
  __typename?: 'TipoCentroConvenzionatoNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TipoCentroConvenzionatoNodeEdge>>;
};

/** A Relay edge containing a `TipoCentroConvenzionatoNode` and its cursor. */
export type TipoCentroConvenzionatoNodeEdge = {
  __typename?: 'TipoCentroConvenzionatoNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<TipoCentroConvenzionatoNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type TreeNodeNode = Node & {
  __typename?: 'TreeNodeNode';
  nameIt?: Maybe<Scalars['String']>;
  nameMobileIt?: Maybe<Scalars['String']>;
  ctaLabelIt?: Maybe<Scalars['String']>;
  descriptionIt?: Maybe<Scalars['String']>;
  descriptionHtmlIt?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  lft: Scalars['Int'];
  rgt: Scalars['Int'];
  treeId: Scalars['Int'];
  depth: Scalars['Int'];
  alias?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  attivo?: Maybe<Scalars['Boolean']>;
  blank: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  nameMobile?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  ctaLabel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imageMobile?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  linkedObjectId?: Maybe<Scalars['Int']>;
  /** Query string aggiunto all'url della pagina linkata */
  linkedQueryString?: Maybe<Scalars['String']>;
  /** Id di un elemento o paragrafo all'interno della pagina linkata */
  linkedAnchorId?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  finalUrl?: Maybe<Scalars['String']>;
  offerta?: Maybe<OffertaNode>;
  faq?: Maybe<FaqNode>;
  children?: Maybe<TreeNodeNodeConnection>;
};


export type TreeNodeNodeChildrenArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  depth?: Maybe<Scalars['Int']>;
  attivo?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['Decimal']>;
};

export type TreeNodeNodeConnection = {
  __typename?: 'TreeNodeNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TreeNodeNodeEdge>>;
};

/** A Relay edge containing a `TreeNodeNode` and its cursor. */
export type TreeNodeNodeEdge = {
  __typename?: 'TreeNodeNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<TreeNodeNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};


export type UtenteNode = Node & {
  __typename?: 'UtenteNode';
  /** The ID of the object */
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** Attribuisce all'utente tutti i privilegi, senza che sia necessario assegnarli esplicitamente. */
  isSuperuser: Scalars['Boolean'];
  guid: Scalars['UUID'];
  nome?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  hashEmail?: Maybe<Scalars['String']>;
  telefono?: Maybe<Scalars['String']>;
  isStaff: Scalars['Boolean'];
  /** Indica se l'utente si può loggare o meno */
  isActive: Scalars['Boolean'];
  isLandingCarrozzerie: Scalars['Boolean'];
  dateJoined: Scalars['DateTime'];
  privacy: Scalars['Boolean'];
  privacyInformativa: Scalars['Boolean'];
  privacyCommerciale: Scalars['Boolean'];
  privacyProfilazione: Scalars['Boolean'];
  sesso?: Maybe<Scalars['String']>;
  dataNascita?: Maybe<Scalars['Date']>;
  /** Registrazione tramite social completata */
  socialCompleted: Scalars['Boolean'];
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  indirizzo: IndirizzoNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  edit?: Maybe<Scalars['Boolean']>;
  completed?: Maybe<Scalars['Boolean']>;
  dataRegistrazione?: Maybe<Scalars['String']>;
  isImpersonate?: Maybe<Scalars['Boolean']>;
  stopImpersonateUrl?: Maybe<Scalars['String']>;
};


export type UtenteNodeIndirizzoArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  nome?: Maybe<Scalars['String']>;
  cognome?: Maybe<Scalars['String']>;
  indirizzo?: Maybe<Scalars['String']>;
  citta?: Maybe<Scalars['String']>;
  provincia?: Maybe<Scalars['String']>;
  cap?: Maybe<Scalars['String']>;
  utente?: Maybe<Scalars['ID']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
};

export type VeicoloNode = Node & {
  __typename?: 'VeicoloNode';
  /** The ID of the object */
  id: Scalars['ID'];
  alias: Scalars['String'];
  /** Codice Infocar del veicolo */
  codiceInfocar: Scalars['String'];
  /** Nome inserito per in fase di configurazione della vetrina */
  nome?: Maybe<Scalars['String']>;
  modello?: Maybe<Scalars['String']>;
  allestimento?: Maybe<Scalars['String']>;
  /** optional di serie (concatenati) */
  optionalDiSerie?: Maybe<Scalars['String']>;
  /** optional (concatenati) */
  optional?: Maybe<Scalars['String']>;
  /** Consumi inseriti manualmente */
  consumi?: Maybe<Scalars['String']>;
  /** Eco Impact inserito manualmente */
  ecoImpactCo2?: Maybe<Scalars['String']>;
  /** Potenza in KW del veicolo */
  potenzaKw?: Maybe<Scalars['String']>;
  /** Prezzo veicolo Infocar (escluso optional) F.C. iva esclusa */
  prezzoFcIe?: Maybe<Scalars['Float']>;
  /** Prezzo chiavi in mano i.i. IPT esc - Escluso optional */
  prezzoFcIi?: Maybe<Scalars['Float']>;
  /** Titolo della sezione con immagine ambientata */
  titoloSezioneAmbientata?: Maybe<Scalars['String']>;
  /** Descrizione della sezione con immagine ambientata */
  descrizioneSezioneAmbientata?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  offerte: OffertaNodeConnection;
  pk?: Maybe<Scalars['Int']>;
  marca?: Maybe<MarcaVeicoloNode>;
  categoria?: Maybe<CategoriaVeicoloNode>;
  alimentazione?: Maybe<Scalars['String']>;
  cambio?: Maybe<Scalars['String']>;
  cambioAutomatico?: Maybe<Scalars['Boolean']>;
  mainImmagineStatica?: Maybe<Scalars['String']>;
  mainImmagineDinamica?: Maybe<Scalars['String']>;
  immaginiStatiche?: Maybe<Array<Maybe<Scalars['String']>>>;
  immaginiDinamiche?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type VeicoloNodeOfferteArgs = {
  offset?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  promoWeb?: Maybe<Scalars['Boolean']>;
};

export type VeicoloNodeConnection = {
  __typename?: 'VeicoloNodeConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VeicoloNodeEdge>>;
};

/** A Relay edge containing a `VeicoloNode` and its cursor. */
export type VeicoloNodeEdge = {
  __typename?: 'VeicoloNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<VeicoloNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar'];
};

export type CategoriaQueryVariables = Exact<{
  slug: Scalars['String'];
  parent?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type CategoriaQuery = (
  { __typename?: 'Query' }
  & { categoria?: Maybe<(
    { __typename?: 'CategoriaNode' }
    & Pick<CategoriaNode, 'pk' | 'slug' | 'codice' | 'tipo' | 'nome' | 'titolo' | 'descrizione' | 'image' | 'adminUrl' | 'visibile' | 'modelClass' | 'pubblicato' | 'visibilitaDal' | 'visibilitaAl' | 'filtriId'>
    & { parent?: Maybe<(
      { __typename?: 'CategoriaNode' }
      & Pick<CategoriaNode, 'pk' | 'tipo' | 'codice' | 'filtriId' | 'url'>
    )>, categoriaPrimariaDefault?: Maybe<(
      { __typename?: 'CategoriaNode' }
      & Pick<CategoriaNode, 'pk' | 'codice'>
    )>, categoriePrimarie?: Maybe<Array<Maybe<(
      { __typename?: 'CategoriaNode' }
      & Pick<CategoriaNode, 'pk' | 'codice' | 'titolo' | 'nome' | 'url' | 'icona' | 'filtriId'>
    )>>>, offerte?: Maybe<Array<Maybe<(
      { __typename?: 'OffertaNode' }
      & Pick<OffertaNode, 'pk' | 'idOfferta' | 'titolo' | 'nome' | 'url' | 'consegna60gg' | 'prontaConsegna' | 'gammaEcologica' | 'autoMese' | 'anticipoZero' | 'promoWeb' | 'condizioniKm' | 'condizioniMesi' | 'anticipoIi' | 'anticipoIe' | 'prezzoIi' | 'prezzoIe'>
      & { veicolo?: Maybe<(
        { __typename?: 'VeicoloNode' }
        & Pick<VeicoloNode, 'nome' | 'modello' | 'allestimento' | 'mainImmagineStatica'>
        & { categoria?: Maybe<(
          { __typename?: 'CategoriaVeicoloNode' }
          & Pick<CategoriaVeicoloNode, 'nome' | 'slug'>
        )> }
      )> }
    )>>>, pagina?: Maybe<(
      { __typename?: 'PaginaNode' }
      & Pick<PaginaNode, 'titolo' | 'nome' | 'descrizione' | 'chiave'>
      & { breadcrumbs?: Maybe<Array<Maybe<(
        { __typename?: 'BreadcrumbType' }
        & Pick<BreadcrumbType, 'label' | 'url'>
      )>>>, seo?: Maybe<(
        { __typename?: 'SeoType' }
        & Pick<SeoType, 'title' | 'description' | 'image' | 'noindex'>
      )> }
    )> }
  )> }
);

export type AllComunicatiQueryVariables = Exact<{ [key: string]: never; }>;


export type AllComunicatiQuery = (
  { __typename?: 'Query' }
  & { allComunicati?: Maybe<(
    { __typename?: 'ComunicatiTypeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'ComunicatiTypeEdge' }
      & { node?: Maybe<(
        { __typename?: 'ComunicatiType' }
        & Pick<ComunicatiType, 'pk' | 'titolo' | 'url' | 'dataPubblicazione' | 'descrizione'>
      )> }
    )>> }
  )> }
);

export type ComunicatiQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ComunicatiQuery = (
  { __typename?: 'Query' }
  & { comunicati?: Maybe<(
    { __typename?: 'ComunicatiType' }
    & Pick<ComunicatiType, 'pk' | 'titolo' | 'descrizione' | 'allegato' | 'dataPubblicazione'>
    & { pagina?: Maybe<(
      { __typename?: 'PaginaNode' }
      & Pick<PaginaNode, 'pk' | 'model' | 'titolo' | 'nome' | 'descrizione' | 'chiave' | 'mainImage' | 'previewImage'>
      & { breadcrumbs?: Maybe<Array<Maybe<(
        { __typename?: 'BreadcrumbType' }
        & Pick<BreadcrumbType, 'label' | 'url'>
      )>>>, seo?: Maybe<(
        { __typename?: 'SeoType' }
        & Pick<SeoType, 'title' | 'description' | 'image' | 'noindex'>
      )> }
    )> }
  )> }
);

export type CreateRichiestaContattoMutationVariables = Exact<{
  input: RichiestaContattoInput;
}>;


export type CreateRichiestaContattoMutation = (
  { __typename?: 'Mutation' }
  & { createRichiestaContatto?: Maybe<(
    { __typename?: 'CreateRichiestaContatto' }
    & Pick<CreateRichiestaContatto, 'status' | 'message' | 'leadId'>
  )> }
);

export type FaqFrequentiQueryVariables = Exact<{
  faq_frequenti: Scalars['Boolean'];
}>;


export type FaqFrequentiQuery = (
  { __typename?: 'Query' }
  & { faqFrequenti?: Maybe<Array<Maybe<(
    { __typename?: 'FaqNode' }
    & Pick<FaqNode, 'domanda' | 'risposta' | 'ordine' | 'url'>
    & { categoria: (
      { __typename?: 'CategoriaFaqNode' }
      & Pick<CategoriaFaqNode, 'macroCategoria'>
    ) }
  )>>> }
);

export type CategorieFaqDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieFaqDetailQuery = (
  { __typename?: 'Query' }
  & { categorieFaq?: Maybe<(
    { __typename?: 'CategoriaFaqNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'CategoriaFaqNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'CategoriaFaqNode' }
        & Pick<CategoriaFaqNode, 'titolo' | 'slug' | 'url' | 'macroCategoria' | 'chiaveIcona'>
        & { faq?: Maybe<Array<Maybe<(
          { __typename?: 'FaqNode' }
          & Pick<FaqNode, 'domanda' | 'risposta' | 'url' | 'ordine' | 'slug'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type CategoriaFaqQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type CategoriaFaqQuery = (
  { __typename?: 'Query' }
  & { categoriaFaq?: Maybe<(
    { __typename?: 'CategoriaFaqNode' }
    & Pick<CategoriaFaqNode, 'titolo' | 'slug' | 'url' | 'macroCategoria'>
    & { pagina?: Maybe<(
      { __typename?: 'PaginaNode' }
      & Pick<PaginaNode, 'titolo' | 'nome' | 'descrizione' | 'chiave'>
      & { breadcrumbs?: Maybe<Array<Maybe<(
        { __typename?: 'BreadcrumbType' }
        & Pick<BreadcrumbType, 'label' | 'url'>
      )>>>, seo?: Maybe<(
        { __typename?: 'SeoType' }
        & Pick<SeoType, 'title' | 'description' | 'image' | 'noindex'>
      )> }
    )> }
  )> }
);

export type AllNewsQueryVariables = Exact<{
  orderBy: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
}>;


export type AllNewsQuery = (
  { __typename?: 'Query' }
  & { allNews?: Maybe<(
    { __typename?: 'NewsTypeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'NewsTypeEdge' }
      & { node?: Maybe<(
        { __typename?: 'NewsType' }
        & Pick<NewsType, 'pk' | 'titolo' | 'descrizione' | 'immagine' | 'slug' | 'url' | 'dataPubblicazione' | 'allegato'>
        & { tags: Array<(
          { __typename?: 'TagType' }
          & Pick<TagType, 'pk' | 'nome'>
        )> }
      )> }
    )>> }
  )> }
);

export type NewsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type NewsQuery = (
  { __typename?: 'Query' }
  & { news?: Maybe<(
    { __typename?: 'NewsType' }
    & Pick<NewsType, 'pk' | 'titolo' | 'descrizione' | 'immagine' | 'allegato' | 'dataPubblicazione' | 'url'>
    & { tags: Array<(
      { __typename?: 'TagType' }
      & Pick<TagType, 'pk' | 'nome'>
    )>, newsCorrelate?: Maybe<Array<Maybe<(
      { __typename?: 'NewsType' }
      & Pick<NewsType, 'titolo' | 'descrizione' | 'url' | 'immagine' | 'allegato' | 'dataPubblicazione'>
      & { tags: Array<(
        { __typename?: 'TagType' }
        & Pick<TagType, 'pk' | 'nome'>
      )> }
    )>>>, pagina?: Maybe<(
      { __typename?: 'PaginaNode' }
      & Pick<PaginaNode, 'pk' | 'model' | 'titolo' | 'nome' | 'descrizione' | 'chiave' | 'mainImage' | 'previewImage'>
      & { breadcrumbs?: Maybe<Array<Maybe<(
        { __typename?: 'BreadcrumbType' }
        & Pick<BreadcrumbType, 'label' | 'url'>
      )>>>, seo?: Maybe<(
        { __typename?: 'SeoType' }
        & Pick<SeoType, 'title' | 'description' | 'image' | 'noindex'>
      )> }
    )> }
  )> }
);

export type AllMagazineQueryVariables = Exact<{
  orderBy: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
}>;


export type AllMagazineQuery = (
  { __typename?: 'Query' }
  & { allMagazine?: Maybe<(
    { __typename?: 'MagazineTypeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'MagazineTypeEdge' }
      & { node?: Maybe<(
        { __typename?: 'MagazineType' }
        & Pick<MagazineType, 'pk' | 'titolo' | 'descrizione' | 'immagine' | 'slug' | 'url' | 'dataPubblicazione' | 'allegato'>
        & { tags: Array<(
          { __typename?: 'TagType' }
          & Pick<TagType, 'pk' | 'nome'>
        )> }
      )> }
    )>> }
  )> }
);

export type MagazineQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type MagazineQuery = (
  { __typename?: 'Query' }
  & { magazine?: Maybe<(
    { __typename?: 'MagazineType' }
    & Pick<MagazineType, 'pk' | 'titolo' | 'descrizione' | 'immagine' | 'allegato' | 'dataPubblicazione' | 'url'>
    & { tags: Array<(
      { __typename?: 'TagType' }
      & Pick<TagType, 'pk' | 'nome'>
    )>, newsCorrelate?: Maybe<Array<Maybe<(
      { __typename?: 'MagazineType' }
      & Pick<MagazineType, 'titolo' | 'descrizione' | 'url' | 'immagine' | 'allegato' | 'dataPubblicazione'>
      & { tags: Array<(
        { __typename?: 'TagType' }
        & Pick<TagType, 'pk' | 'nome'>
      )> }
    )>>>, pagina?: Maybe<(
      { __typename?: 'PaginaNode' }
      & Pick<PaginaNode, 'pk' | 'model' | 'titolo' | 'nome' | 'descrizione' | 'chiave' | 'mainImage' | 'previewImage'>
      & { breadcrumbs?: Maybe<Array<Maybe<(
        { __typename?: 'BreadcrumbType' }
        & Pick<BreadcrumbType, 'label' | 'url'>
      )>>>, seo?: Maybe<(
        { __typename?: 'SeoType' }
        & Pick<SeoType, 'title' | 'description' | 'image' | 'noindex'>
      )> }
    )> }
  )> }
);

export type CreateUtenteNewsletterMutationVariables = Exact<{
  input: RichiestaIscrizioneNewsletterInput;
}>;


export type CreateUtenteNewsletterMutation = (
  { __typename?: 'Mutation' }
  & { createUtenteNewsletter?: Maybe<(
    { __typename?: 'CreateUtenteNewsletter' }
    & Pick<CreateUtenteNewsletter, 'status' | 'message'>
  )> }
);

export type CategorieVeicoliQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieVeicoliQuery = (
  { __typename?: 'Query' }
  & { categorieVeicoli?: Maybe<(
    { __typename?: 'CategoriaVeicoloNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'CategoriaVeicoloNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'CategoriaVeicoloNode' }
        & Pick<CategoriaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
      )> }
    )>> }
  )> }
);

export type MarcheVeicoliQueryVariables = Exact<{ [key: string]: never; }>;


export type MarcheVeicoliQuery = (
  { __typename?: 'Query' }
  & { marche?: Maybe<(
    { __typename?: 'MarcaVeicoloNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'MarcaVeicoloNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'MarcaVeicoloNode' }
        & Pick<MarcaVeicoloNode, 'pk' | 'nome' | 'slug' | 'url' | 'image'>
      )> }
    )>> }
  )> }
);

export type OffertaQueryVariables = Exact<{
  slug: Scalars['String'];
  categoria?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type OffertaQuery = (
  { __typename?: 'Query' }
  & { offerta?: Maybe<(
    { __typename?: 'OffertaNode' }
    & Pick<OffertaNode, 'pk' | 'idOfferta' | 'slug' | 'titolo' | 'nome' | 'url' | 'adminUrl' | 'visibile' | 'modelClass' | 'pubblicato' | 'visibilitaDal' | 'visibilitaAl' | 'note' | 'consegna60gg' | 'prontaConsegna' | 'gammaEcologica' | 'autoMese' | 'anticipoZero' | 'promoWeb' | 'condizioniKm' | 'condizioniMesi' | 'anticipoIi' | 'anticipoIe' | 'prezzoIi' | 'prezzoIe'>
    & { scaglioni?: Maybe<Array<Maybe<(
      { __typename?: 'ScaglioneNode' }
      & Pick<ScaglioneNode, 'km' | 'mesi' | 'canoneMaxirataIi' | 'canoneMaxirataIe' | 'canoneNoMaxirataIi' | 'canoneNoMaxirataIe' | 'default'>
    )>>>, veicolo?: Maybe<(
      { __typename?: 'VeicoloNode' }
      & Pick<VeicoloNode, 'nome' | 'alias' | 'titoloSezioneAmbientata' | 'descrizioneSezioneAmbientata' | 'modello' | 'potenzaKw' | 'consumi' | 'ecoImpactCo2' | 'optional' | 'allestimento' | 'alimentazione' | 'cambio' | 'cambioAutomatico' | 'mainImmagineStatica' | 'mainImmagineDinamica' | 'immaginiStatiche' | 'immaginiDinamiche' | 'codiceInfocar'>
      & { marca?: Maybe<(
        { __typename?: 'MarcaVeicoloNode' }
        & Pick<MarcaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
      )>, categoria?: Maybe<(
        { __typename?: 'CategoriaVeicoloNode' }
        & Pick<CategoriaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
      )> }
    )>, faqs?: Maybe<Array<Maybe<(
      { __typename?: 'FaqNode' }
      & Pick<FaqNode, 'pk' | 'domanda' | 'risposta'>
    )>>>, offerteCorrelate?: Maybe<Array<Maybe<(
      { __typename?: 'OffertaNode' }
      & Pick<OffertaNode, 'pk' | 'idOfferta' | 'slug' | 'titolo' | 'nome' | 'url' | 'note' | 'consegna60gg' | 'prontaConsegna' | 'gammaEcologica' | 'autoMese' | 'anticipoZero' | 'promoWeb' | 'condizioniKm' | 'condizioniMesi' | 'anticipoIi' | 'anticipoIe' | 'prezzoIi' | 'prezzoIe'>
      & { veicolo?: Maybe<(
        { __typename?: 'VeicoloNode' }
        & Pick<VeicoloNode, 'nome' | 'potenzaKw' | 'consumi' | 'ecoImpactCo2' | 'optional' | 'allestimento' | 'alimentazione' | 'cambio' | 'cambioAutomatico' | 'mainImmagineStatica' | 'immaginiStatiche'>
        & { marca?: Maybe<(
          { __typename?: 'MarcaVeicoloNode' }
          & Pick<MarcaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
        )>, categoria?: Maybe<(
          { __typename?: 'CategoriaVeicoloNode' }
          & Pick<CategoriaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
        )> }
      )> }
    )>>>, pagina?: Maybe<(
      { __typename?: 'PaginaNode' }
      & { seo?: Maybe<(
        { __typename?: 'SeoType' }
        & Pick<SeoType, 'title' | 'description' | 'image' | 'noindex'>
      )>, breadcrumbs?: Maybe<Array<Maybe<(
        { __typename?: 'BreadcrumbType' }
        & Pick<BreadcrumbType, 'label' | 'url'>
      )>>> }
    )>, categoria?: Maybe<(
      { __typename?: 'CategoriaNode' }
      & Pick<CategoriaNode, 'titolo' | 'codice'>
    )> }
  )> }
);

export type OfferteQueryVariables = Exact<{
  promoWeb?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type OfferteQuery = (
  { __typename?: 'Query' }
  & { offerte?: Maybe<(
    { __typename?: 'OffertaNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'OffertaNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'OffertaNode' }
        & Pick<OffertaNode, 'pk' | 'idOfferta' | 'slug' | 'titolo' | 'nome' | 'url' | 'modelClass' | 'note' | 'consegna60gg' | 'prontaConsegna' | 'gammaEcologica' | 'autoMese' | 'anticipoZero' | 'promoWeb' | 'condizioniKm' | 'condizioniMesi' | 'anticipoIi' | 'anticipoIe' | 'prezzoIi' | 'prezzoIe'>
        & { veicolo?: Maybe<(
          { __typename?: 'VeicoloNode' }
          & Pick<VeicoloNode, 'nome' | 'titoloSezioneAmbientata' | 'descrizioneSezioneAmbientata' | 'modello' | 'potenzaKw' | 'consumi' | 'ecoImpactCo2' | 'optional' | 'allestimento' | 'alimentazione' | 'cambio' | 'cambioAutomatico' | 'mainImmagineStatica' | 'mainImmagineDinamica' | 'immaginiStatiche' | 'immaginiDinamiche'>
          & { marca?: Maybe<(
            { __typename?: 'MarcaVeicoloNode' }
            & Pick<MarcaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
          )>, categoria?: Maybe<(
            { __typename?: 'CategoriaVeicoloNode' }
            & Pick<CategoriaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
          )> }
        )> }
      )> }
    )>> }
  )> }
);

export type OfferteBySlugQueryVariables = Exact<{
  slugs?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type OfferteBySlugQuery = (
  { __typename?: 'Query' }
  & { offerteBySlug?: Maybe<Array<Maybe<(
    { __typename?: 'OffertaNode' }
    & Pick<OffertaNode, 'pk' | 'idOfferta' | 'slug' | 'titolo' | 'nome' | 'url' | 'modelClass' | 'note' | 'consegna60gg' | 'prontaConsegna' | 'gammaEcologica' | 'autoMese' | 'anticipoZero' | 'promoWeb' | 'condizioniKm' | 'condizioniMesi' | 'anticipoIi' | 'anticipoIe' | 'prezzoIi' | 'prezzoIe'>
    & { veicolo?: Maybe<(
      { __typename?: 'VeicoloNode' }
      & Pick<VeicoloNode, 'nome' | 'titoloSezioneAmbientata' | 'descrizioneSezioneAmbientata' | 'modello' | 'potenzaKw' | 'consumi' | 'ecoImpactCo2' | 'optional' | 'allestimento' | 'alimentazione' | 'cambio' | 'cambioAutomatico' | 'mainImmagineStatica' | 'mainImmagineDinamica' | 'immaginiStatiche' | 'immaginiDinamiche'>
      & { marca?: Maybe<(
        { __typename?: 'MarcaVeicoloNode' }
        & Pick<MarcaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
      )>, categoria?: Maybe<(
        { __typename?: 'CategoriaVeicoloNode' }
        & Pick<CategoriaVeicoloNode, 'pk' | 'nome' | 'slug' | 'image' | 'url'>
      )> }
    )> }
  )>>> }
);

export type OffertaRedirectQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type OffertaRedirectQuery = (
  { __typename?: 'Query' }
  & { offertaRedirect?: Maybe<(
    { __typename?: 'RedirectType' }
    & Pick<RedirectType, 'redirect'>
  )> }
);

export type PaginaQueryVariables = Exact<{
  chiave?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  contentTypeId?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
  siteId?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Boolean']>;
}>;


export type PaginaQuery = (
  { __typename?: 'Query' }
  & { pagina?: Maybe<(
    { __typename?: 'PaginaNode' }
    & Pick<PaginaNode, 'pk' | 'model' | 'titolo' | 'nome' | 'descrizione' | 'chiave' | 'mainImage' | 'previewImage' | 'adminUrl' | 'modelClass' | 'visibile' | 'pubblicato' | 'visibilitaDal' | 'visibilitaAl'>
    & { breadcrumbs?: Maybe<Array<Maybe<(
      { __typename?: 'BreadcrumbType' }
      & Pick<BreadcrumbType, 'label' | 'url'>
    )>>>, seo?: Maybe<(
      { __typename?: 'SeoType' }
      & Pick<SeoType, 'title' | 'description' | 'image' | 'noindex'>
    )> }
  )> }
);

export type PagineCatchAllQueryVariables = Exact<{ [key: string]: never; }>;


export type PagineCatchAllQuery = (
  { __typename?: 'Query' }
  & { pagine?: Maybe<(
    { __typename?: 'PaginaNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'PaginaNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'PaginaNode' }
        & Pick<PaginaNode, 'path'>
      )> }
    )>> }
  )> }
);

export type SearchQueryVariables = Exact<{
  query: Scalars['String'];
  models?: Maybe<Array<Maybe<Modello>> | Maybe<Modello>>;
  limitAutocomplete?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type SearchQuery = (
  { __typename?: 'Query' }
  & { search?: Maybe<(
    { __typename?: 'SearchConnection' }
    & Pick<SearchConnection, 'totalCount' | 'count' | 'suggestion'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'SearchEdge' }
      & { node?: Maybe<(
        { __typename?: 'SearchType' }
        & Pick<SearchType, 'modelName' | 'score' | 'url'>
        & { object?: Maybe<(
          { __typename?: 'CategoriaNode' }
          & Pick<CategoriaNode, 'titolo' | 'nome' | 'tipo' | 'codice' | 'url'>
        ) | (
          { __typename?: 'OffertaNode' }
          & Pick<OffertaNode, 'titolo' | 'url'>
          & { veicolo?: Maybe<(
            { __typename?: 'VeicoloNode' }
            & Pick<VeicoloNode, 'mainImmagineStatica'>
          )> }
        ) | (
          { __typename?: 'NewsType' }
          & Pick<NewsType, 'titolo' | 'descrizione' | 'immagine' | 'slug' | 'url' | 'dataPubblicazione' | 'allegato'>
          & { tags: Array<(
            { __typename?: 'TagType' }
            & Pick<TagType, 'pk' | 'nome'>
          )> }
        ) | (
          { __typename?: 'MagazineType' }
          & Pick<MagazineType, 'titolo' | 'descrizione' | 'immagine' | 'slug' | 'url' | 'dataPubblicazione' | 'allegato'>
          & { tags: Array<(
            { __typename?: 'TagType' }
            & Pick<TagType, 'pk' | 'nome'>
          )> }
        ) | (
          { __typename?: 'ComunicatiType' }
          & Pick<ComunicatiType, 'titolo' | 'url' | 'dataPubblicazione' | 'descrizione'>
        ) | (
          { __typename?: 'PaginaNode' }
          & Pick<PaginaNode, 'titolo' | 'descrizione' | 'chiave' | 'url'>
        ) | (
          { __typename?: 'FaqNode' }
          & Pick<FaqNode, 'titolo' | 'domanda' | 'risposta' | 'ordine' | 'url'>
        )> }
      )> }
    )>>, autocomplete?: Maybe<(
      { __typename?: 'AutocompleteConnection' }
      & Pick<AutocompleteConnection, 'totalCount' | 'count'>
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ), edges: Array<Maybe<(
        { __typename?: 'AutocompleteEdge' }
        & { node?: Maybe<(
          { __typename?: 'SearchType' }
          & Pick<SearchType, 'modelName' | 'score' | 'url'>
          & { object?: Maybe<(
            { __typename?: 'CategoriaNode' }
            & Pick<CategoriaNode, 'titolo' | 'nome' | 'tipo' | 'codice' | 'url'>
          ) | (
            { __typename?: 'OffertaNode' }
            & Pick<OffertaNode, 'titolo' | 'url'>
            & { veicolo?: Maybe<(
              { __typename?: 'VeicoloNode' }
              & Pick<VeicoloNode, 'mainImmagineStatica'>
            )> }
          ) | (
            { __typename?: 'NewsType' }
            & Pick<NewsType, 'titolo' | 'descrizione' | 'immagine' | 'slug' | 'url' | 'dataPubblicazione' | 'allegato'>
            & { tags: Array<(
              { __typename?: 'TagType' }
              & Pick<TagType, 'pk' | 'nome'>
            )> }
          ) | (
            { __typename?: 'MagazineType' }
            & Pick<MagazineType, 'titolo' | 'descrizione' | 'immagine' | 'slug' | 'url' | 'dataPubblicazione' | 'allegato'>
            & { tags: Array<(
              { __typename?: 'TagType' }
              & Pick<TagType, 'pk' | 'nome'>
            )> }
          ) | (
            { __typename?: 'ComunicatiType' }
            & Pick<ComunicatiType, 'titolo' | 'url' | 'dataPubblicazione' | 'descrizione'>
          ) | (
            { __typename?: 'PaginaNode' }
            & Pick<PaginaNode, 'titolo' | 'descrizione' | 'chiave' | 'url'>
          ) | (
            { __typename?: 'FaqNode' }
            & Pick<FaqNode, 'titolo' | 'domanda' | 'risposta' | 'ordine' | 'url'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type AutocompleteQueryVariables = Exact<{
  query: Scalars['String'];
  models?: Maybe<Array<Maybe<Modello>> | Maybe<Modello>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type AutocompleteQuery = (
  { __typename?: 'Query' }
  & { autocomplete?: Maybe<(
    { __typename?: 'AutocompleteConnection' }
    & Pick<AutocompleteConnection, 'totalCount' | 'count' | 'suggestion'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ), edges: Array<Maybe<(
      { __typename?: 'AutocompleteEdge' }
      & { node?: Maybe<(
        { __typename?: 'SearchType' }
        & Pick<SearchType, 'modelName' | 'score' | 'url'>
        & { object?: Maybe<(
          { __typename?: 'CategoriaNode' }
          & Pick<CategoriaNode, 'titolo' | 'nome' | 'tipo' | 'codice' | 'url'>
        ) | (
          { __typename?: 'OffertaNode' }
          & Pick<OffertaNode, 'titolo' | 'url'>
          & { veicolo?: Maybe<(
            { __typename?: 'VeicoloNode' }
            & Pick<VeicoloNode, 'mainImmagineStatica'>
          )> }
        ) | (
          { __typename?: 'NewsType' }
          & Pick<NewsType, 'titolo' | 'descrizione' | 'immagine' | 'slug' | 'url' | 'dataPubblicazione' | 'allegato'>
          & { tags: Array<(
            { __typename?: 'TagType' }
            & Pick<TagType, 'pk' | 'nome'>
          )> }
        ) | (
          { __typename?: 'MagazineType' }
          & Pick<MagazineType, 'titolo' | 'descrizione' | 'immagine' | 'slug' | 'url' | 'dataPubblicazione' | 'allegato'>
          & { tags: Array<(
            { __typename?: 'TagType' }
            & Pick<TagType, 'pk' | 'nome'>
          )> }
        ) | (
          { __typename?: 'ComunicatiType' }
          & Pick<ComunicatiType, 'titolo' | 'url' | 'dataPubblicazione' | 'descrizione'>
        ) | (
          { __typename?: 'PaginaNode' }
          & Pick<PaginaNode, 'titolo' | 'descrizione' | 'chiave' | 'url'>
        ) | (
          { __typename?: 'FaqNode' }
          & Pick<FaqNode, 'titolo' | 'domanda' | 'risposta' | 'ordine' | 'url'>
        )> }
      )> }
    )>> }
  )> }
);

export type FilialiQueryVariables = Exact<{ [key: string]: never; }>;


export type FilialiQuery = (
  { __typename?: 'Query' }
  & { filiali?: Maybe<(
    { __typename?: 'FilialeNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'FilialeNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'FilialeNode' }
        & Pick<FilialeNode, 'pk' | 'ragioneSociale' | 'titolo' | 'indirizzo' | 'cap' | 'comune' | 'provincia' | 'telefono' | 'latitudine' | 'longitudine' | 'email' | 'fax' | 'orari' | 'url'>
      )> }
    )>> }
  )> }
);

export type AgenzieQueryVariables = Exact<{ [key: string]: never; }>;


export type AgenzieQuery = (
  { __typename?: 'Query' }
  & { agenzie?: Maybe<(
    { __typename?: 'AgenziaNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'AgenziaNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'AgenziaNode' }
        & Pick<AgenziaNode, 'pk' | 'ragioneSociale' | 'indirizzo' | 'cap' | 'comune' | 'provincia' | 'telefono' | 'latitudine' | 'longitudine' | 'codice' | 'email'>
      )> }
    )>> }
  )> }
);

export type TipiCentriConvenzionatiQueryVariables = Exact<{ [key: string]: never; }>;


export type TipiCentriConvenzionatiQuery = (
  { __typename?: 'Query' }
  & { tipiCentriConvenzionati?: Maybe<(
    { __typename?: 'TipoCentroConvenzionatoNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'TipoCentroConvenzionatoNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'TipoCentroConvenzionatoNode' }
        & Pick<TipoCentroConvenzionatoNode, 'pk' | 'nome' | 'nomeStatico'>
        & { marcaTipoCentro?: Maybe<Array<Maybe<(
          { __typename?: 'MarcaCentroConvenzionatoNode' }
          & Pick<MarcaCentroConvenzionatoNode, 'pk' | 'marca'>
        )>>> }
      )> }
    )>> }
  )> }
);

export type MarcheCentroConvenzionatoQueryVariables = Exact<{
  tipo_pk: Scalars['ID'];
}>;


export type MarcheCentroConvenzionatoQuery = (
  { __typename?: 'Query' }
  & { marcheTipoCentroConvenzionato?: Maybe<(
    { __typename?: 'MarcaCentroConvenzionatoNodeConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'MarcaCentroConvenzionatoNodeEdge' }
      & { node?: Maybe<(
        { __typename?: 'MarcaCentroConvenzionatoNode' }
        & Pick<MarcaCentroConvenzionatoNode, 'pk' | 'marca'>
      )> }
    )>> }
  )> }
);

export type FilialeQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type FilialeQuery = (
  { __typename?: 'Query' }
  & { filiale?: Maybe<(
    { __typename?: 'FilialeNode' }
    & Pick<FilialeNode, 'pk' | 'ragioneSociale' | 'titolo' | 'indirizzo' | 'cap' | 'comune' | 'provincia' | 'telefono' | 'latitudine' | 'longitudine' | 'email' | 'fax' | 'orari' | 'url'>
    & { pagina?: Maybe<(
      { __typename?: 'PaginaNode' }
      & Pick<PaginaNode, 'titolo' | 'nome' | 'descrizione' | 'chiave'>
      & { breadcrumbs?: Maybe<Array<Maybe<(
        { __typename?: 'BreadcrumbType' }
        & Pick<BreadcrumbType, 'label' | 'url'>
      )>>>, seo?: Maybe<(
        { __typename?: 'SeoType' }
        & Pick<SeoType, 'title' | 'description' | 'image' | 'noindex'>
      )> }
    )> }
  )> }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'UtenteNode' }
    & Pick<UtenteNode, 'pk' | 'email' | 'hashEmail' | 'nome' | 'cognome' | 'completed' | 'isStaff' | 'isLandingCarrozzerie' | 'edit' | 'isImpersonate' | 'stopImpersonateUrl'>
  )> }
);

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { tokenAuth?: Maybe<(
    { __typename?: 'ObtainJSONWebToken' }
    & Pick<ObtainJsonWebToken, 'token'>
    & { user?: Maybe<(
      { __typename?: 'UtenteNode' }
      & Pick<UtenteNode, 'pk' | 'nome' | 'cognome' | 'email' | 'hashEmail' | 'isLandingCarrozzerie'>
    )> }
  )> }
);

export type RecuperaPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RecuperaPasswordMutation = (
  { __typename?: 'Mutation' }
  & { recuperaPassword?: Maybe<(
    { __typename?: 'RecuperaPassword' }
    & Pick<RecuperaPassword, 'status' | 'hashEmail'>
  )> }
);

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: Maybe<(
    { __typename?: 'ResetPassword' }
    & Pick<ResetPassword, 'status'>
  )> }
);


export const CategoriaDocument = gql`
    query Categoria($slug: String!, $parent: String, $preview: Boolean) {
  categoria(slug: $slug, parent: $parent, preview: $preview) {
    pk
    slug
    codice
    tipo
    nome
    titolo
    descrizione
    image
    adminUrl
    visibile
    modelClass
    pubblicato
    visibilitaDal
    visibilitaAl
    filtriId
    parent {
      pk
      tipo
      codice
      filtriId
      url
    }
    categoriaPrimariaDefault {
      pk
      codice
    }
    categoriePrimarie {
      pk
      codice
      titolo
      nome
      url
      icona
      filtriId
    }
    offerte {
      pk
      idOfferta
      titolo
      nome
      url
      consegna60gg
      prontaConsegna
      gammaEcologica
      autoMese
      anticipoZero
      promoWeb
      veicolo {
        nome
        modello
        allestimento
        mainImmagineStatica
        categoria {
          nome
          slug
        }
      }
      condizioniKm
      condizioniMesi
      anticipoIi
      anticipoIe
      prezzoIi
      prezzoIe
    }
    pagina {
      titolo
      nome
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
      }
      descrizione
      chiave
    }
  }
}
    `;

/**
 * __useCategoriaQuery__
 *
 * To run a query within a React component, call `useCategoriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriaQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      parent: // value for 'parent'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useCategoriaQuery(baseOptions: Apollo.QueryHookOptions<CategoriaQuery, CategoriaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriaQuery, CategoriaQueryVariables>(CategoriaDocument, options);
      }
export function useCategoriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriaQuery, CategoriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriaQuery, CategoriaQueryVariables>(CategoriaDocument, options);
        }
export type CategoriaQueryHookResult = ReturnType<typeof useCategoriaQuery>;
export type CategoriaLazyQueryHookResult = ReturnType<typeof useCategoriaLazyQuery>;
export type CategoriaQueryResult = Apollo.QueryResult<CategoriaQuery, CategoriaQueryVariables>;
export const AllComunicatiDocument = gql`
    query allComunicati {
  allComunicati {
    edges {
      node {
        pk
        titolo
        url
        dataPubblicazione
        descrizione
      }
    }
  }
}
    `;

/**
 * __useAllComunicatiQuery__
 *
 * To run a query within a React component, call `useAllComunicatiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllComunicatiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllComunicatiQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllComunicatiQuery(baseOptions?: Apollo.QueryHookOptions<AllComunicatiQuery, AllComunicatiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllComunicatiQuery, AllComunicatiQueryVariables>(AllComunicatiDocument, options);
      }
export function useAllComunicatiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllComunicatiQuery, AllComunicatiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllComunicatiQuery, AllComunicatiQueryVariables>(AllComunicatiDocument, options);
        }
export type AllComunicatiQueryHookResult = ReturnType<typeof useAllComunicatiQuery>;
export type AllComunicatiLazyQueryHookResult = ReturnType<typeof useAllComunicatiLazyQuery>;
export type AllComunicatiQueryResult = Apollo.QueryResult<AllComunicatiQuery, AllComunicatiQueryVariables>;
export const ComunicatiDocument = gql`
    query Comunicati($slug: String!) {
  comunicati(slug: $slug) {
    pk
    titolo
    descrizione
    allegato
    dataPubblicazione
    pagina {
      pk
      model
      titolo
      nome
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
      }
      descrizione
      chiave
      mainImage
      previewImage
    }
  }
}
    `;

/**
 * __useComunicatiQuery__
 *
 * To run a query within a React component, call `useComunicatiQuery` and pass it any options that fit your needs.
 * When your component renders, `useComunicatiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComunicatiQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useComunicatiQuery(baseOptions: Apollo.QueryHookOptions<ComunicatiQuery, ComunicatiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComunicatiQuery, ComunicatiQueryVariables>(ComunicatiDocument, options);
      }
export function useComunicatiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComunicatiQuery, ComunicatiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComunicatiQuery, ComunicatiQueryVariables>(ComunicatiDocument, options);
        }
export type ComunicatiQueryHookResult = ReturnType<typeof useComunicatiQuery>;
export type ComunicatiLazyQueryHookResult = ReturnType<typeof useComunicatiLazyQuery>;
export type ComunicatiQueryResult = Apollo.QueryResult<ComunicatiQuery, ComunicatiQueryVariables>;
export const CreateRichiestaContattoDocument = gql`
    mutation createRichiestaContatto($input: RichiestaContattoInput!) {
  createRichiestaContatto(input: $input) {
    status
    message
    leadId
  }
}
    `;
export type CreateRichiestaContattoMutationFn = Apollo.MutationFunction<CreateRichiestaContattoMutation, CreateRichiestaContattoMutationVariables>;

/**
 * __useCreateRichiestaContattoMutation__
 *
 * To run a mutation, you first call `useCreateRichiestaContattoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRichiestaContattoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRichiestaContattoMutation, { data, loading, error }] = useCreateRichiestaContattoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRichiestaContattoMutation(baseOptions?: Apollo.MutationHookOptions<CreateRichiestaContattoMutation, CreateRichiestaContattoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRichiestaContattoMutation, CreateRichiestaContattoMutationVariables>(CreateRichiestaContattoDocument, options);
      }
export type CreateRichiestaContattoMutationHookResult = ReturnType<typeof useCreateRichiestaContattoMutation>;
export type CreateRichiestaContattoMutationResult = Apollo.MutationResult<CreateRichiestaContattoMutation>;
export type CreateRichiestaContattoMutationOptions = Apollo.BaseMutationOptions<CreateRichiestaContattoMutation, CreateRichiestaContattoMutationVariables>;
export const FaqFrequentiDocument = gql`
    query FaqFrequenti($faq_frequenti: Boolean!) {
  faqFrequenti(faqFrequenti: $faq_frequenti) {
    domanda
    risposta
    ordine
    url
    categoria {
      macroCategoria
    }
  }
}
    `;

/**
 * __useFaqFrequentiQuery__
 *
 * To run a query within a React component, call `useFaqFrequentiQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqFrequentiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqFrequentiQuery({
 *   variables: {
 *      faq_frequenti: // value for 'faq_frequenti'
 *   },
 * });
 */
export function useFaqFrequentiQuery(baseOptions: Apollo.QueryHookOptions<FaqFrequentiQuery, FaqFrequentiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqFrequentiQuery, FaqFrequentiQueryVariables>(FaqFrequentiDocument, options);
      }
export function useFaqFrequentiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqFrequentiQuery, FaqFrequentiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqFrequentiQuery, FaqFrequentiQueryVariables>(FaqFrequentiDocument, options);
        }
export type FaqFrequentiQueryHookResult = ReturnType<typeof useFaqFrequentiQuery>;
export type FaqFrequentiLazyQueryHookResult = ReturnType<typeof useFaqFrequentiLazyQuery>;
export type FaqFrequentiQueryResult = Apollo.QueryResult<FaqFrequentiQuery, FaqFrequentiQueryVariables>;
export const CategorieFaqDetailDocument = gql`
    query CategorieFaqDetail {
  categorieFaq {
    edges {
      node {
        titolo
        slug
        url
        macroCategoria
        chiaveIcona
        faq {
          domanda
          risposta
          url
          ordine
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useCategorieFaqDetailQuery__
 *
 * To run a query within a React component, call `useCategorieFaqDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieFaqDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieFaqDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieFaqDetailQuery(baseOptions?: Apollo.QueryHookOptions<CategorieFaqDetailQuery, CategorieFaqDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieFaqDetailQuery, CategorieFaqDetailQueryVariables>(CategorieFaqDetailDocument, options);
      }
export function useCategorieFaqDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieFaqDetailQuery, CategorieFaqDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieFaqDetailQuery, CategorieFaqDetailQueryVariables>(CategorieFaqDetailDocument, options);
        }
export type CategorieFaqDetailQueryHookResult = ReturnType<typeof useCategorieFaqDetailQuery>;
export type CategorieFaqDetailLazyQueryHookResult = ReturnType<typeof useCategorieFaqDetailLazyQuery>;
export type CategorieFaqDetailQueryResult = Apollo.QueryResult<CategorieFaqDetailQuery, CategorieFaqDetailQueryVariables>;
export const CategoriaFaqDocument = gql`
    query CategoriaFaq($slug: String!) {
  categoriaFaq(slug: $slug) {
    titolo
    slug
    url
    macroCategoria
    pagina {
      titolo
      nome
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
      }
      descrizione
      chiave
    }
  }
}
    `;

/**
 * __useCategoriaFaqQuery__
 *
 * To run a query within a React component, call `useCategoriaFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriaFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriaFaqQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCategoriaFaqQuery(baseOptions: Apollo.QueryHookOptions<CategoriaFaqQuery, CategoriaFaqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriaFaqQuery, CategoriaFaqQueryVariables>(CategoriaFaqDocument, options);
      }
export function useCategoriaFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriaFaqQuery, CategoriaFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriaFaqQuery, CategoriaFaqQueryVariables>(CategoriaFaqDocument, options);
        }
export type CategoriaFaqQueryHookResult = ReturnType<typeof useCategoriaFaqQuery>;
export type CategoriaFaqLazyQueryHookResult = ReturnType<typeof useCategoriaFaqLazyQuery>;
export type CategoriaFaqQueryResult = Apollo.QueryResult<CategoriaFaqQuery, CategoriaFaqQueryVariables>;
export const AllNewsDocument = gql`
    query AllNews($orderBy: String!, $first: Int) {
  allNews(orderBy: $orderBy, first: $first) {
    edges {
      node {
        pk
        titolo
        descrizione
        immagine
        slug
        url
        dataPubblicazione
        allegato
        tags {
          pk
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useAllNewsQuery__
 *
 * To run a query within a React component, call `useAllNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNewsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllNewsQuery(baseOptions: Apollo.QueryHookOptions<AllNewsQuery, AllNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllNewsQuery, AllNewsQueryVariables>(AllNewsDocument, options);
      }
export function useAllNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllNewsQuery, AllNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllNewsQuery, AllNewsQueryVariables>(AllNewsDocument, options);
        }
export type AllNewsQueryHookResult = ReturnType<typeof useAllNewsQuery>;
export type AllNewsLazyQueryHookResult = ReturnType<typeof useAllNewsLazyQuery>;
export type AllNewsQueryResult = Apollo.QueryResult<AllNewsQuery, AllNewsQueryVariables>;
export const NewsDocument = gql`
    query News($slug: String!) {
  news(slug: $slug) {
    pk
    titolo
    descrizione
    immagine
    allegato
    dataPubblicazione
    url
    tags {
      pk
      nome
    }
    newsCorrelate {
      titolo
      descrizione
      url
      immagine
      allegato
      dataPubblicazione
      tags {
        pk
        nome
      }
    }
    pagina {
      pk
      model
      titolo
      nome
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
      }
      descrizione
      chiave
      mainImage
      previewImage
    }
  }
}
    `;

/**
 * __useNewsQuery__
 *
 * To run a query within a React component, call `useNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useNewsQuery(baseOptions: Apollo.QueryHookOptions<NewsQuery, NewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsQuery, NewsQueryVariables>(NewsDocument, options);
      }
export function useNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsQuery, NewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsQuery, NewsQueryVariables>(NewsDocument, options);
        }
export type NewsQueryHookResult = ReturnType<typeof useNewsQuery>;
export type NewsLazyQueryHookResult = ReturnType<typeof useNewsLazyQuery>;
export type NewsQueryResult = Apollo.QueryResult<NewsQuery, NewsQueryVariables>;
export const AllMagazineDocument = gql`
    query AllMagazine($orderBy: String!, $first: Int) {
  allMagazine(orderBy: $orderBy, first: $first) {
    edges {
      node {
        pk
        titolo
        descrizione
        immagine
        slug
        url
        dataPubblicazione
        allegato
        tags {
          pk
          nome
        }
      }
    }
  }
}
    `;

/**
 * __useAllMagazineQuery__
 *
 * To run a query within a React component, call `useAllMagazineQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMagazineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMagazineQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllMagazineQuery(baseOptions: Apollo.QueryHookOptions<AllMagazineQuery, AllMagazineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMagazineQuery, AllMagazineQueryVariables>(AllMagazineDocument, options);
      }
export function useAllMagazineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMagazineQuery, AllMagazineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMagazineQuery, AllMagazineQueryVariables>(AllMagazineDocument, options);
        }
export type AllMagazineQueryHookResult = ReturnType<typeof useAllMagazineQuery>;
export type AllMagazineLazyQueryHookResult = ReturnType<typeof useAllMagazineLazyQuery>;
export type AllMagazineQueryResult = Apollo.QueryResult<AllMagazineQuery, AllMagazineQueryVariables>;
export const MagazineDocument = gql`
    query Magazine($slug: String!) {
  magazine(slug: $slug) {
    pk
    titolo
    descrizione
    immagine
    allegato
    dataPubblicazione
    url
    tags {
      pk
      nome
    }
    newsCorrelate {
      titolo
      descrizione
      url
      immagine
      allegato
      dataPubblicazione
      tags {
        pk
        nome
      }
    }
    pagina {
      pk
      model
      titolo
      nome
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
      }
      descrizione
      chiave
      mainImage
      previewImage
    }
  }
}
    `;

/**
 * __useMagazineQuery__
 *
 * To run a query within a React component, call `useMagazineQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagazineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagazineQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useMagazineQuery(baseOptions: Apollo.QueryHookOptions<MagazineQuery, MagazineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagazineQuery, MagazineQueryVariables>(MagazineDocument, options);
      }
export function useMagazineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagazineQuery, MagazineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagazineQuery, MagazineQueryVariables>(MagazineDocument, options);
        }
export type MagazineQueryHookResult = ReturnType<typeof useMagazineQuery>;
export type MagazineLazyQueryHookResult = ReturnType<typeof useMagazineLazyQuery>;
export type MagazineQueryResult = Apollo.QueryResult<MagazineQuery, MagazineQueryVariables>;
export const CreateUtenteNewsletterDocument = gql`
    mutation createUtenteNewsletter($input: RichiestaIscrizioneNewsletterInput!) {
  createUtenteNewsletter(input: $input) {
    status
    message
  }
}
    `;
export type CreateUtenteNewsletterMutationFn = Apollo.MutationFunction<CreateUtenteNewsletterMutation, CreateUtenteNewsletterMutationVariables>;

/**
 * __useCreateUtenteNewsletterMutation__
 *
 * To run a mutation, you first call `useCreateUtenteNewsletterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUtenteNewsletterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUtenteNewsletterMutation, { data, loading, error }] = useCreateUtenteNewsletterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUtenteNewsletterMutation(baseOptions?: Apollo.MutationHookOptions<CreateUtenteNewsletterMutation, CreateUtenteNewsletterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUtenteNewsletterMutation, CreateUtenteNewsletterMutationVariables>(CreateUtenteNewsletterDocument, options);
      }
export type CreateUtenteNewsletterMutationHookResult = ReturnType<typeof useCreateUtenteNewsletterMutation>;
export type CreateUtenteNewsletterMutationResult = Apollo.MutationResult<CreateUtenteNewsletterMutation>;
export type CreateUtenteNewsletterMutationOptions = Apollo.BaseMutationOptions<CreateUtenteNewsletterMutation, CreateUtenteNewsletterMutationVariables>;
export const CategorieVeicoliDocument = gql`
    query CategorieVeicoli {
  categorieVeicoli {
    edges {
      node {
        pk
        nome
        slug
        image
        url
      }
    }
  }
}
    `;

/**
 * __useCategorieVeicoliQuery__
 *
 * To run a query within a React component, call `useCategorieVeicoliQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieVeicoliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieVeicoliQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieVeicoliQuery(baseOptions?: Apollo.QueryHookOptions<CategorieVeicoliQuery, CategorieVeicoliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieVeicoliQuery, CategorieVeicoliQueryVariables>(CategorieVeicoliDocument, options);
      }
export function useCategorieVeicoliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieVeicoliQuery, CategorieVeicoliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieVeicoliQuery, CategorieVeicoliQueryVariables>(CategorieVeicoliDocument, options);
        }
export type CategorieVeicoliQueryHookResult = ReturnType<typeof useCategorieVeicoliQuery>;
export type CategorieVeicoliLazyQueryHookResult = ReturnType<typeof useCategorieVeicoliLazyQuery>;
export type CategorieVeicoliQueryResult = Apollo.QueryResult<CategorieVeicoliQuery, CategorieVeicoliQueryVariables>;
export const MarcheVeicoliDocument = gql`
    query MarcheVeicoli {
  marche {
    edges {
      node {
        pk
        nome
        slug
        url
        image
        url
      }
    }
  }
}
    `;

/**
 * __useMarcheVeicoliQuery__
 *
 * To run a query within a React component, call `useMarcheVeicoliQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarcheVeicoliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarcheVeicoliQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarcheVeicoliQuery(baseOptions?: Apollo.QueryHookOptions<MarcheVeicoliQuery, MarcheVeicoliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarcheVeicoliQuery, MarcheVeicoliQueryVariables>(MarcheVeicoliDocument, options);
      }
export function useMarcheVeicoliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarcheVeicoliQuery, MarcheVeicoliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarcheVeicoliQuery, MarcheVeicoliQueryVariables>(MarcheVeicoliDocument, options);
        }
export type MarcheVeicoliQueryHookResult = ReturnType<typeof useMarcheVeicoliQuery>;
export type MarcheVeicoliLazyQueryHookResult = ReturnType<typeof useMarcheVeicoliLazyQuery>;
export type MarcheVeicoliQueryResult = Apollo.QueryResult<MarcheVeicoliQuery, MarcheVeicoliQueryVariables>;
export const OffertaDocument = gql`
    query Offerta($slug: String!, $categoria: String, $preview: Boolean) {
  offerta(slug: $slug, categoria: $categoria, preview: $preview) {
    pk
    idOfferta
    slug
    titolo
    nome
    url
    adminUrl
    visibile
    modelClass
    pubblicato
    visibilitaDal
    visibilitaAl
    note
    consegna60gg
    prontaConsegna
    gammaEcologica
    autoMese
    anticipoZero
    promoWeb
    condizioniKm
    condizioniMesi
    anticipoIi
    anticipoIe
    prezzoIi
    prezzoIe
    scaglioni {
      km
      mesi
      canoneMaxirataIi
      canoneMaxirataIe
      canoneNoMaxirataIi
      canoneNoMaxirataIe
      default
    }
    veicolo {
      nome
      alias
      titoloSezioneAmbientata
      descrizioneSezioneAmbientata
      marca {
        pk
        nome
        slug
        image
        url
      }
      categoria {
        pk
        nome
        slug
        image
        url
      }
      modello
      potenzaKw
      consumi
      ecoImpactCo2
      optional
      allestimento
      alimentazione
      cambio
      cambioAutomatico
      mainImmagineStatica
      mainImmagineDinamica
      immaginiStatiche
      immaginiDinamiche
      codiceInfocar
    }
    faqs {
      pk
      domanda
      risposta
    }
    offerteCorrelate {
      pk
      idOfferta
      slug
      titolo
      nome
      url
      note
      consegna60gg
      prontaConsegna
      gammaEcologica
      autoMese
      anticipoZero
      promoWeb
      condizioniKm
      condizioniMesi
      anticipoIi
      anticipoIe
      prezzoIi
      prezzoIe
      veicolo {
        nome
        marca {
          pk
          nome
          slug
          image
          url
        }
        categoria {
          pk
          nome
          slug
          image
          url
        }
        potenzaKw
        consumi
        ecoImpactCo2
        optional
        allestimento
        alimentazione
        cambio
        cambioAutomatico
        mainImmagineStatica
        immaginiStatiche
      }
    }
    pagina {
      seo {
        title
        description
        image
        noindex
      }
      breadcrumbs {
        label
        url
      }
    }
    categoria {
      titolo
      codice
    }
  }
}
    `;

/**
 * __useOffertaQuery__
 *
 * To run a query within a React component, call `useOffertaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffertaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffertaQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      categoria: // value for 'categoria'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useOffertaQuery(baseOptions: Apollo.QueryHookOptions<OffertaQuery, OffertaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffertaQuery, OffertaQueryVariables>(OffertaDocument, options);
      }
export function useOffertaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffertaQuery, OffertaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffertaQuery, OffertaQueryVariables>(OffertaDocument, options);
        }
export type OffertaQueryHookResult = ReturnType<typeof useOffertaQuery>;
export type OffertaLazyQueryHookResult = ReturnType<typeof useOffertaLazyQuery>;
export type OffertaQueryResult = Apollo.QueryResult<OffertaQuery, OffertaQueryVariables>;
export const OfferteDocument = gql`
    query Offerte($promoWeb: Boolean, $first: Int) {
  offerte(promoWeb: $promoWeb, first: $first) {
    edges {
      node {
        pk
        idOfferta
        slug
        titolo
        nome
        url
        modelClass
        note
        consegna60gg
        prontaConsegna
        gammaEcologica
        autoMese
        anticipoZero
        promoWeb
        condizioniKm
        condizioniMesi
        anticipoIi
        anticipoIe
        prezzoIi
        prezzoIe
        veicolo {
          nome
          titoloSezioneAmbientata
          descrizioneSezioneAmbientata
          marca {
            pk
            nome
            slug
            image
            url
          }
          categoria {
            pk
            nome
            slug
            image
            url
          }
          modello
          potenzaKw
          consumi
          ecoImpactCo2
          optional
          allestimento
          alimentazione
          cambio
          cambioAutomatico
          mainImmagineStatica
          mainImmagineDinamica
          immaginiStatiche
          immaginiDinamiche
        }
      }
    }
  }
}
    `;

/**
 * __useOfferteQuery__
 *
 * To run a query within a React component, call `useOfferteQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferteQuery({
 *   variables: {
 *      promoWeb: // value for 'promoWeb'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useOfferteQuery(baseOptions?: Apollo.QueryHookOptions<OfferteQuery, OfferteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferteQuery, OfferteQueryVariables>(OfferteDocument, options);
      }
export function useOfferteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferteQuery, OfferteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferteQuery, OfferteQueryVariables>(OfferteDocument, options);
        }
export type OfferteQueryHookResult = ReturnType<typeof useOfferteQuery>;
export type OfferteLazyQueryHookResult = ReturnType<typeof useOfferteLazyQuery>;
export type OfferteQueryResult = Apollo.QueryResult<OfferteQuery, OfferteQueryVariables>;
export const OfferteBySlugDocument = gql`
    query OfferteBySlug($slugs: [String]) {
  offerteBySlug(slugs: $slugs) {
    pk
    idOfferta
    slug
    titolo
    nome
    url
    modelClass
    note
    consegna60gg
    prontaConsegna
    gammaEcologica
    autoMese
    anticipoZero
    promoWeb
    condizioniKm
    condizioniMesi
    anticipoIi
    anticipoIe
    prezzoIi
    prezzoIe
    veicolo {
      nome
      titoloSezioneAmbientata
      descrizioneSezioneAmbientata
      marca {
        pk
        nome
        slug
        image
        url
      }
      categoria {
        pk
        nome
        slug
        image
        url
      }
      modello
      potenzaKw
      consumi
      ecoImpactCo2
      optional
      allestimento
      alimentazione
      cambio
      cambioAutomatico
      mainImmagineStatica
      mainImmagineDinamica
      immaginiStatiche
      immaginiDinamiche
    }
  }
}
    `;

/**
 * __useOfferteBySlugQuery__
 *
 * To run a query within a React component, call `useOfferteBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferteBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferteBySlugQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useOfferteBySlugQuery(baseOptions?: Apollo.QueryHookOptions<OfferteBySlugQuery, OfferteBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferteBySlugQuery, OfferteBySlugQueryVariables>(OfferteBySlugDocument, options);
      }
export function useOfferteBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferteBySlugQuery, OfferteBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferteBySlugQuery, OfferteBySlugQueryVariables>(OfferteBySlugDocument, options);
        }
export type OfferteBySlugQueryHookResult = ReturnType<typeof useOfferteBySlugQuery>;
export type OfferteBySlugLazyQueryHookResult = ReturnType<typeof useOfferteBySlugLazyQuery>;
export type OfferteBySlugQueryResult = Apollo.QueryResult<OfferteBySlugQuery, OfferteBySlugQueryVariables>;
export const OffertaRedirectDocument = gql`
    query OffertaRedirect($slug: String!) {
  offertaRedirect(slug: $slug) {
    redirect
  }
}
    `;

/**
 * __useOffertaRedirectQuery__
 *
 * To run a query within a React component, call `useOffertaRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffertaRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffertaRedirectQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useOffertaRedirectQuery(baseOptions: Apollo.QueryHookOptions<OffertaRedirectQuery, OffertaRedirectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffertaRedirectQuery, OffertaRedirectQueryVariables>(OffertaRedirectDocument, options);
      }
export function useOffertaRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffertaRedirectQuery, OffertaRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffertaRedirectQuery, OffertaRedirectQueryVariables>(OffertaRedirectDocument, options);
        }
export type OffertaRedirectQueryHookResult = ReturnType<typeof useOffertaRedirectQuery>;
export type OffertaRedirectLazyQueryHookResult = ReturnType<typeof useOffertaRedirectLazyQuery>;
export type OffertaRedirectQueryResult = Apollo.QueryResult<OffertaRedirectQuery, OffertaRedirectQueryVariables>;
export const PaginaDocument = gql`
    query Pagina($chiave: String, $path: String, $contentTypeId: Int, $objectId: Int, $siteId: Int, $preview: Boolean) {
  pagina(
    chiave: $chiave
    path: $path
    contentTypeId: $contentTypeId
    objectId: $objectId
    siteId: $siteId
    preview: $preview
  ) {
    pk
    model
    titolo
    nome
    breadcrumbs {
      label
      url
    }
    seo {
      title
      description
      image
      noindex
    }
    descrizione
    chiave
    mainImage
    previewImage
    adminUrl
    modelClass
    visibile
    pubblicato
    visibilitaDal
    visibilitaAl
  }
}
    `;

/**
 * __usePaginaQuery__
 *
 * To run a query within a React component, call `usePaginaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginaQuery({
 *   variables: {
 *      chiave: // value for 'chiave'
 *      path: // value for 'path'
 *      contentTypeId: // value for 'contentTypeId'
 *      objectId: // value for 'objectId'
 *      siteId: // value for 'siteId'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function usePaginaQuery(baseOptions?: Apollo.QueryHookOptions<PaginaQuery, PaginaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginaQuery, PaginaQueryVariables>(PaginaDocument, options);
      }
export function usePaginaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginaQuery, PaginaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginaQuery, PaginaQueryVariables>(PaginaDocument, options);
        }
export type PaginaQueryHookResult = ReturnType<typeof usePaginaQuery>;
export type PaginaLazyQueryHookResult = ReturnType<typeof usePaginaLazyQuery>;
export type PaginaQueryResult = Apollo.QueryResult<PaginaQuery, PaginaQueryVariables>;
export const PagineCatchAllDocument = gql`
    query PagineCatchAll {
  pagine(tipologia: PAGE) {
    edges {
      node {
        path
      }
    }
  }
}
    `;

/**
 * __usePagineCatchAllQuery__
 *
 * To run a query within a React component, call `usePagineCatchAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagineCatchAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagineCatchAllQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagineCatchAllQuery(baseOptions?: Apollo.QueryHookOptions<PagineCatchAllQuery, PagineCatchAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagineCatchAllQuery, PagineCatchAllQueryVariables>(PagineCatchAllDocument, options);
      }
export function usePagineCatchAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagineCatchAllQuery, PagineCatchAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagineCatchAllQuery, PagineCatchAllQueryVariables>(PagineCatchAllDocument, options);
        }
export type PagineCatchAllQueryHookResult = ReturnType<typeof usePagineCatchAllQuery>;
export type PagineCatchAllLazyQueryHookResult = ReturnType<typeof usePagineCatchAllLazyQuery>;
export type PagineCatchAllQueryResult = Apollo.QueryResult<PagineCatchAllQuery, PagineCatchAllQueryVariables>;
export const SearchDocument = gql`
    query Search($query: String!, $models: [Modello], $limitAutocomplete: Int, $first: Int, $last: Int, $after: String, $before: String) {
  search(
    query: $query
    models: $models
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    count
    edges {
      node {
        modelName
        score
        url
        object {
          ... on OffertaNode {
            titolo
            url
            veicolo {
              mainImmagineStatica
            }
          }
          ... on CategoriaNode {
            titolo
            nome
            tipo
            codice
            url
          }
          ... on NewsType {
            titolo
            descrizione
            immagine
            slug
            url
            dataPubblicazione
            allegato
            tags {
              pk
              nome
            }
          }
          ... on MagazineType {
            titolo
            descrizione
            immagine
            slug
            url
            dataPubblicazione
            allegato
            tags {
              pk
              nome
            }
          }
          ... on ComunicatiType {
            titolo
            url
            dataPubblicazione
            descrizione
          }
          ... on PaginaNode {
            titolo
            descrizione
            chiave
            url
          }
          ... on FaqNode {
            titolo
            domanda
            risposta
            ordine
            url
          }
        }
      }
    }
    suggestion(query: $query)
    autocomplete(query: $query, models: $models, first: $limitAutocomplete) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      count
      edges {
        node {
          modelName
          score
          url
          object {
            ... on OffertaNode {
              titolo
              url
              veicolo {
                mainImmagineStatica
              }
            }
            ... on CategoriaNode {
              titolo
              nome
              tipo
              codice
              url
            }
            ... on NewsType {
              titolo
              descrizione
              immagine
              slug
              url
              dataPubblicazione
              allegato
              tags {
                pk
                nome
              }
            }
            ... on MagazineType {
              titolo
              descrizione
              immagine
              slug
              url
              dataPubblicazione
              allegato
              tags {
                pk
                nome
              }
            }
            ... on ComunicatiType {
              titolo
              url
              dataPubblicazione
              descrizione
            }
            ... on PaginaNode {
              titolo
              descrizione
              chiave
              url
            }
            ... on FaqNode {
              titolo
              domanda
              risposta
              ordine
              url
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      models: // value for 'models'
 *      limitAutocomplete: // value for 'limitAutocomplete'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const AutocompleteDocument = gql`
    query Autocomplete($query: String!, $models: [Modello], $first: Int, $last: Int, $after: String, $before: String) {
  autocomplete(
    query: $query
    models: $models
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    count
    suggestion(query: $query)
    edges {
      node {
        modelName
        score
        url
        object {
          ... on OffertaNode {
            titolo
            url
            veicolo {
              mainImmagineStatica
            }
          }
          ... on CategoriaNode {
            titolo
            nome
            tipo
            codice
            url
          }
          ... on NewsType {
            titolo
            descrizione
            immagine
            slug
            url
            dataPubblicazione
            allegato
            tags {
              pk
              nome
            }
          }
          ... on MagazineType {
            titolo
            descrizione
            immagine
            slug
            url
            dataPubblicazione
            allegato
            tags {
              pk
              nome
            }
          }
          ... on ComunicatiType {
            titolo
            url
            dataPubblicazione
            descrizione
          }
          ... on PaginaNode {
            titolo
            descrizione
            chiave
            url
          }
          ... on FaqNode {
            titolo
            domanda
            risposta
            ordine
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAutocompleteQuery__
 *
 * To run a query within a React component, call `useAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *      models: // value for 'models'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<AutocompleteQuery, AutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteQuery, AutocompleteQueryVariables>(AutocompleteDocument, options);
      }
export function useAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteQuery, AutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteQuery, AutocompleteQueryVariables>(AutocompleteDocument, options);
        }
export type AutocompleteQueryHookResult = ReturnType<typeof useAutocompleteQuery>;
export type AutocompleteLazyQueryHookResult = ReturnType<typeof useAutocompleteLazyQuery>;
export type AutocompleteQueryResult = Apollo.QueryResult<AutocompleteQuery, AutocompleteQueryVariables>;
export const FilialiDocument = gql`
    query Filiali {
  filiali {
    edges {
      node {
        pk
        ragioneSociale
        titolo
        indirizzo
        cap
        comune
        provincia
        telefono
        latitudine
        longitudine
        email
        fax
        orari
        url
      }
    }
  }
}
    `;

/**
 * __useFilialiQuery__
 *
 * To run a query within a React component, call `useFilialiQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilialiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilialiQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilialiQuery(baseOptions?: Apollo.QueryHookOptions<FilialiQuery, FilialiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilialiQuery, FilialiQueryVariables>(FilialiDocument, options);
      }
export function useFilialiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilialiQuery, FilialiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilialiQuery, FilialiQueryVariables>(FilialiDocument, options);
        }
export type FilialiQueryHookResult = ReturnType<typeof useFilialiQuery>;
export type FilialiLazyQueryHookResult = ReturnType<typeof useFilialiLazyQuery>;
export type FilialiQueryResult = Apollo.QueryResult<FilialiQuery, FilialiQueryVariables>;
export const AgenzieDocument = gql`
    query Agenzie {
  agenzie {
    edges {
      node {
        pk
        ragioneSociale
        indirizzo
        cap
        comune
        provincia
        telefono
        latitudine
        longitudine
        codice
        email
      }
    }
  }
}
    `;

/**
 * __useAgenzieQuery__
 *
 * To run a query within a React component, call `useAgenzieQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgenzieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgenzieQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgenzieQuery(baseOptions?: Apollo.QueryHookOptions<AgenzieQuery, AgenzieQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgenzieQuery, AgenzieQueryVariables>(AgenzieDocument, options);
      }
export function useAgenzieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgenzieQuery, AgenzieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgenzieQuery, AgenzieQueryVariables>(AgenzieDocument, options);
        }
export type AgenzieQueryHookResult = ReturnType<typeof useAgenzieQuery>;
export type AgenzieLazyQueryHookResult = ReturnType<typeof useAgenzieLazyQuery>;
export type AgenzieQueryResult = Apollo.QueryResult<AgenzieQuery, AgenzieQueryVariables>;
export const TipiCentriConvenzionatiDocument = gql`
    query TipiCentriConvenzionati {
  tipiCentriConvenzionati {
    edges {
      node {
        pk
        nome
        nomeStatico
        marcaTipoCentro {
          pk
          marca
        }
      }
    }
  }
}
    `;

/**
 * __useTipiCentriConvenzionatiQuery__
 *
 * To run a query within a React component, call `useTipiCentriConvenzionatiQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipiCentriConvenzionatiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipiCentriConvenzionatiQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipiCentriConvenzionatiQuery(baseOptions?: Apollo.QueryHookOptions<TipiCentriConvenzionatiQuery, TipiCentriConvenzionatiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TipiCentriConvenzionatiQuery, TipiCentriConvenzionatiQueryVariables>(TipiCentriConvenzionatiDocument, options);
      }
export function useTipiCentriConvenzionatiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TipiCentriConvenzionatiQuery, TipiCentriConvenzionatiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TipiCentriConvenzionatiQuery, TipiCentriConvenzionatiQueryVariables>(TipiCentriConvenzionatiDocument, options);
        }
export type TipiCentriConvenzionatiQueryHookResult = ReturnType<typeof useTipiCentriConvenzionatiQuery>;
export type TipiCentriConvenzionatiLazyQueryHookResult = ReturnType<typeof useTipiCentriConvenzionatiLazyQuery>;
export type TipiCentriConvenzionatiQueryResult = Apollo.QueryResult<TipiCentriConvenzionatiQuery, TipiCentriConvenzionatiQueryVariables>;
export const MarcheCentroConvenzionatoDocument = gql`
    query MarcheCentroConvenzionato($tipo_pk: ID!) {
  marcheTipoCentroConvenzionato(tipoId: $tipo_pk) {
    edges {
      node {
        pk
        marca
      }
    }
  }
}
    `;

/**
 * __useMarcheCentroConvenzionatoQuery__
 *
 * To run a query within a React component, call `useMarcheCentroConvenzionatoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarcheCentroConvenzionatoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarcheCentroConvenzionatoQuery({
 *   variables: {
 *      tipo_pk: // value for 'tipo_pk'
 *   },
 * });
 */
export function useMarcheCentroConvenzionatoQuery(baseOptions: Apollo.QueryHookOptions<MarcheCentroConvenzionatoQuery, MarcheCentroConvenzionatoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarcheCentroConvenzionatoQuery, MarcheCentroConvenzionatoQueryVariables>(MarcheCentroConvenzionatoDocument, options);
      }
export function useMarcheCentroConvenzionatoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarcheCentroConvenzionatoQuery, MarcheCentroConvenzionatoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarcheCentroConvenzionatoQuery, MarcheCentroConvenzionatoQueryVariables>(MarcheCentroConvenzionatoDocument, options);
        }
export type MarcheCentroConvenzionatoQueryHookResult = ReturnType<typeof useMarcheCentroConvenzionatoQuery>;
export type MarcheCentroConvenzionatoLazyQueryHookResult = ReturnType<typeof useMarcheCentroConvenzionatoLazyQuery>;
export type MarcheCentroConvenzionatoQueryResult = Apollo.QueryResult<MarcheCentroConvenzionatoQuery, MarcheCentroConvenzionatoQueryVariables>;
export const FilialeDocument = gql`
    query Filiale($slug: String!) {
  filiale(slug: $slug) {
    pk
    ragioneSociale
    titolo
    indirizzo
    cap
    comune
    provincia
    telefono
    latitudine
    longitudine
    email
    fax
    orari
    url
    pagina {
      titolo
      nome
      breadcrumbs {
        label
        url
      }
      seo {
        title
        description
        image
        noindex
      }
      descrizione
      chiave
    }
  }
}
    `;

/**
 * __useFilialeQuery__
 *
 * To run a query within a React component, call `useFilialeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilialeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilialeQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useFilialeQuery(baseOptions: Apollo.QueryHookOptions<FilialeQuery, FilialeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilialeQuery, FilialeQueryVariables>(FilialeDocument, options);
      }
export function useFilialeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilialeQuery, FilialeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilialeQuery, FilialeQueryVariables>(FilialeDocument, options);
        }
export type FilialeQueryHookResult = ReturnType<typeof useFilialeQuery>;
export type FilialeLazyQueryHookResult = ReturnType<typeof useFilialeLazyQuery>;
export type FilialeQueryResult = Apollo.QueryResult<FilialeQuery, FilialeQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    pk
    email
    hashEmail
    nome
    cognome
    completed
    isStaff
    isLandingCarrozzerie
    edit
    isImpersonate
    stopImpersonateUrl
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  tokenAuth(email: $email, password: $password) {
    token
    user {
      pk
      nome
      cognome
      email
      hashEmail
      isLandingCarrozzerie
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RecuperaPasswordDocument = gql`
    mutation recuperaPassword($email: String!) {
  recuperaPassword(email: $email) {
    status
    hashEmail
  }
}
    `;
export type RecuperaPasswordMutationFn = Apollo.MutationFunction<RecuperaPasswordMutation, RecuperaPasswordMutationVariables>;

/**
 * __useRecuperaPasswordMutation__
 *
 * To run a mutation, you first call `useRecuperaPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecuperaPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recuperaPasswordMutation, { data, loading, error }] = useRecuperaPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRecuperaPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RecuperaPasswordMutation, RecuperaPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecuperaPasswordMutation, RecuperaPasswordMutationVariables>(RecuperaPasswordDocument, options);
      }
export type RecuperaPasswordMutationHookResult = ReturnType<typeof useRecuperaPasswordMutation>;
export type RecuperaPasswordMutationResult = Apollo.MutationResult<RecuperaPasswordMutation>;
export type RecuperaPasswordMutationOptions = Apollo.BaseMutationOptions<RecuperaPasswordMutation, RecuperaPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $password: String!) {
  resetPassword(password: $password, token: $token) {
    status
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "AgenziaNode",
      "CategoriaFaqNode",
      "CategoriaNode",
      "CategoriaVeicoloNode",
      "CentroConvenzionatoNode",
      "ComunicatiType",
      "FaqNode",
      "FilialeNode",
      "IndirizzoNode",
      "LandingNode",
      "MagazineType",
      "MarcaCentroConvenzionatoNode",
      "MarcaVeicoloNode",
      "NewsType",
      "OffertaLandingNode",
      "OffertaNode",
      "PaginaNode",
      "ScaglioneNode",
      "SearchType",
      "TipoCentroConvenzionatoNode",
      "TreeNodeNode",
      "UtenteNode",
      "VeicoloNode"
    ],
    "SearchObject": [
      "CategoriaNode",
      "OffertaNode",
      "NewsType",
      "MagazineType",
      "ComunicatiType",
      "PaginaNode",
      "FaqNode"
    ]
  }
};
      export default result;
    